webpackJsonp([1],{

/***/ "+MEr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WideCards_vue__ = __webpack_require__("NAvi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_716f5ed5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WideCards_vue__ = __webpack_require__("6yGo");
function injectStyle (ssrContext) {
  __webpack_require__("Sl/G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-716f5ed5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WideCards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_716f5ed5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WideCards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+VXC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_vm._v(" "),_c('router-view',{attrs:{"page-settings":_vm.pageSettings}}),_vm._v(" "),_c('Footer',{attrs:{"page-settings":_vm.pageSettings}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+lfw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2EZ5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5W1q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5yYN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      collection: [{ "paragraph": "<div class=\"container-fluid page_header_style page_header_style_ aos-init aos-animate\" data-aos=\"fade-up\">\n<div class=\"row\">\n<div class=\"container\">\n<div class=\"row modulesTitle\">\n<div class=\"col-xs-12 text-center\">\n<h2 id=\"section-5b467a98f200b-title\" class=\"s123-page-header\">DATENSCHUTZERKL&Auml;RUNG</h2>\n<hr class=\"small\" />\n<h4 id=\"section-5b467a98f200b-slogan\">&nbsp;</h4>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"container aos-init aos-animate\" data-aos=\"fade-up\">\n<div class=\"row text-center\">\n<div class=\"col-xs-12\">\n<div class=\"responsive-handler fr-view breakable\"><strong><u>Datenschutzerkl&auml;rung</u></strong><br />Diese Datenschutzerkl&auml;rung kl&auml;rt Sie &uuml;ber die Art, den Umfang und Zweck der Verarbeitung von personenbezogenen Daten (nachfolgend kurz &bdquo;Daten&ldquo;) innerhalb unseres Onlineangebotes und der mit ihm verbundenen Webseiten, Funktionen und Inhalte sowie externen Onlinepr&auml;senzen, wie z.B. unser Social Media Profile auf (nachfolgend gemeinsam bezeichnet als &bdquo;Onlineangebot&ldquo;). Im Hinblick auf die verwendeten Begrifflichkeiten, wie z.B. &bdquo;Verarbeitung&ldquo; oder &bdquo;Verantwortlicher&ldquo; verweisen wir auf die Definitionen im Art. 4 der Datenschutzgrundverordnung (DSGVO).<br /><br /><strong><u>Verantwortlicher</u><em><br /></em></strong>Nicolas Mandt<strong>&nbsp;(</strong>Dipl. P&auml;d., Kinder- und Jugendlichenpsychotherapeut)<br />Beethovenstra&szlig;e 10, 50674 K&ouml;ln<br />0176 - 44 40 14 24<br />mail@praxismandt.de<br /><br /><u><strong>Arten der verarbeiteten Daten:<br /></strong></u>-Bestandsdaten (z.B., Namen, Adressen).<br />-Kontaktdaten (z.B., E-Mail, Telefonnummern).<br />-Inhaltsdaten (z.B., Texteingaben, Fotografien, Videos).<br />-Nutzungsdaten (z.B., besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten).<br />-Meta-/Kommunikationsdaten (z.B., Ger&auml;te-Informationen, IP-Adressen).<br /><br /><strong><u>Kategorien betroffener Personen<br /></u></strong>Besucher und Nutzer des Onlineangebotes (Nachfolgend bezeichnen wir die betroffenen Personen zusammenfassend auch als &bdquo;Nutzer&ldquo;).<br /><br /><u><strong>Zweck der Verarbeitung<br /></strong></u>-Zurverf&uuml;gungstellung des Onlineangebotes, seiner Funktionen und Inhalte.<br />-Beantwortung von Kontaktanfragen und Kommunikation mit Nutzern.<br />-Sicherheitsma&szlig;nahmen.<br />-Reichweitenmessung/Marketing<br /><br /><u><strong>Verwendete Begrifflichkeiten<br /></strong></u>&bdquo;Personenbezogene Daten&ldquo; sind alle Informationen, die sich auf eine identifizierte oder identifizierbare nat&uuml;rliche Person (im Folgenden &bdquo;betroffene Person&ldquo;) beziehen; als identifizierbar wird eine nat&uuml;rliche Person angesehen, die direkt oder indirekt, insbesondere mittels Zuordnung zu einer Kennung wie einem Namen, zu einer Kennnummer, zu Standortdaten, zu einer Online-Kennung (z.B. Cookie) oder zu einem oder mehreren besonderen Merkmalen identifiziert werden kann, die Ausdruck der physischen, physiologischen, genetischen, psychischen, wirtschaftlichen, kulturellen oder sozialen Identit&auml;t dieser nat&uuml;rlichen Person sind.<br /><br />&bdquo;Verarbeitung&ldquo; ist jeder mit oder ohne Hilfe automatisierter Verfahren ausgef&uuml;hrte Vorgang oder jede solche Vorgangsreihe im Zusammenhang mit personenbezogenen Daten. Der Begriff reicht weit und umfasst praktisch jeden Umgang mit Daten.<br /><br />&bdquo;Pseudonymisierung&ldquo; die Verarbeitung personenbezogener Daten in einer Weise, dass die personenbezogenen Daten ohne Hinzuziehung zus&auml;tzlicher Informationen nicht mehr einer spezifischen betroffenen Person zugeordnet werden k&ouml;nnen, sofern diese zus&auml;tzlichen Informationen gesondert aufbewahrt werden und technischen und organisatorischen Ma&szlig;nahmen unterliegen, die gew&auml;hrleisten, dass die personenbezogenen Daten nicht einer identifizierten oder identifizierbaren nat&uuml;rlichen Person zugewiesen werden.<br /><br />&bdquo;Profiling&ldquo; jede Art der automatisierten Verarbeitung personenbezogener Daten, die darin besteht, dass diese personenbezogenen Daten verwendet werden, um bestimmte pers&ouml;nliche Aspekte, die sich auf eine nat&uuml;rliche Person beziehen, zu bewerten, insbesondere um Aspekte bez&uuml;glich Arbeitsleistung, wirtschaftliche Lage, Gesundheit, pers&ouml;nliche Vorlieben, Interessen, Zuverl&auml;ssigkeit, Verhalten, Aufenthaltsort oder Ortswechsel dieser nat&uuml;rlichen Person zu analysieren oder vorherzusagen.<br /><br />Als &bdquo;Verantwortlicher&ldquo; wird die nat&uuml;rliche oder juristische Person, Beh&ouml;rde, Einrichtung oder andere Stelle, die allein oder gemeinsam mit anderen &uuml;ber die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet, bezeichnet.<br /><br />&bdquo;Auftragsverarbeiter&ldquo; eine nat&uuml;rliche oder juristische Person, Beh&ouml;rde, Einrichtung oder andere Stelle, die personenbezogene Daten im Auftrag des Verantwortlichen verarbeitet.<br /><br /><u><strong>Ma&szlig;gebliche Rechtsgrundlagen<br /></strong></u>Nach Ma&szlig;gabe des Art. 13 DSGVO teilen wir Ihnen die Rechtsgrundlagen unserer Datenverarbeitungen mit. Sofern die Rechtsgrundlage in der Datenschutzerkl&auml;rung nicht genannt wird, gilt Folgendes: Die Rechtsgrundlage f&uuml;r die Einholung von Einwilligungen ist Art. 6 Abs. 1 lit. a und Art. 7 DSGVO, die Rechtsgrundlage f&uuml;r die Verarbeitung zur Erf&uuml;llung unserer Leistungen und Durchf&uuml;hrung vertraglicher Ma&szlig;nahmen sowie Beantwortung von Anfragen ist Art. 6 Abs. 1 lit. b DSGVO, die Rechtsgrundlage f&uuml;r die Verarbeitung zur Erf&uuml;llung unserer rechtlichen Verpflichtungen ist Art. 6 Abs. 1 lit. c DSGVO, und die Rechtsgrundlage f&uuml;r die Verarbeitung zur Wahrung unserer berechtigten Interessen ist Art. 6 Abs. 1 lit. f DSGVO. F&uuml;r den Fall, dass lebenswichtige Interessen der betroffenen Person oder einer anderen nat&uuml;rlichen Person eine Verarbeitung personenbezogener Daten erforderlich machen, dient Art. 6 Abs. 1 lit. d DSGVO als Rechtsgrundlage.<br /><br /><strong><u>Sicherheitsma&szlig;nahmen</u></strong><br />Wir treffen nach Ma&szlig;gabe des Art. 32 DSGVO unter Ber&uuml;cksichtigung des Stands der Technik, der Implementierungskosten und der Art, des Umfangs, der Umst&auml;nde und der Zwecke der Verarbeitung sowie der unterschiedlichen Eintrittswahrscheinlichkeit und Schwere des Risikos f&uuml;r die Rechte und Freiheiten nat&uuml;rlicher Personen, geeignete technische und organisatorische Ma&szlig;nahmen, um ein dem Risiko angemessenes Schutzniveau zu gew&auml;hrleisten.<br /><br />Zu den Ma&szlig;nahmen geh&ouml;ren insbesondere die Sicherung der Vertraulichkeit, Integrit&auml;t und Verf&uuml;gbarkeit von Daten durch Kontrolle des physischen Zugangs zu den Daten, als auch des sie betreffenden Zugriffs, der Eingabe, Weitergabe, der Sicherung der Verf&uuml;gbarkeit und ihrer Trennung. Des Weiteren haben wir Verfahren eingerichtet, die eine Wahrnehmung von Betroffenenrechten, L&ouml;schung von Daten und Reaktion auf Gef&auml;hrdung der Daten gew&auml;hrleisten. Ferner ber&uuml;cksichtigen wir den Schutz personenbezogener Daten bereits bei der Entwicklung, bzw. Auswahl von Hardware, Software sowie Verfahren, entsprechend dem Prinzip des Datenschutzes durch Technikgestaltung und durch datenschutzfreundliche Voreinstellungen (Art. 25 DSGVO).<br /><br /><strong><u>Zusammenarbeit mit Auftragsverarbeitern und Dritten<br /></u></strong>Sofern wir im Rahmen unserer Verarbeitung Daten gegen&uuml;ber anderen Personen und Unternehmen (Auftragsverarbeitern oder Dritten) offenbaren, sie an diese &uuml;bermitteln oder ihnen sonst Zugriff auf die Daten gew&auml;hren, erfolgt dies nur auf Grundlage einer gesetzlichen Erlaubnis (z.B. wenn eine &Uuml;bermittlung der Daten an Dritte, wie an Zahlungsdienstleister, gem. Art. 6 Abs. 1 lit. b DSGVO zur Vertragserf&uuml;llung erforderlich ist), Sie eingewilligt haben, eine rechtliche Verpflichtung dies vorsieht oder auf Grundlage unserer berechtigten Interessen (z.B. beim Einsatz von Beauftragten, Webhostern, etc.).<br /><br />Sofern wir Dritte mit der Verarbeitung von Daten auf Grundlage eines sog. &bdquo;Auftragsverarbeitungsvertrages&ldquo; beauftragen, geschieht dies auf Grundlage des Art. 28 DSGVO.<br /><br /><strong><u>&Uuml;bermittlungen in Drittl&auml;nder<br /></u></strong>Sofern wir Daten in einem Drittland (d.h. au&szlig;erhalb der Europ&auml;ischen Union (EU) oder des Europ&auml;ischen Wirtschaftsraums (EWR)) verarbeiten oder dies im Rahmen der Inanspruchnahme von Diensten Dritter oder Offenlegung, bzw. &Uuml;bermittlung von Daten an Dritte geschieht, erfolgt dies nur, wenn es zur Erf&uuml;llung unserer (vor)vertraglichen Pflichten, auf Grundlage Ihrer Einwilligung, aufgrund einer rechtlichen Verpflichtung oder auf Grundlage unserer berechtigten Interessen geschieht. Vorbehaltlich gesetzlicher oder vertraglicher Erlaubnisse, verarbeiten oder lassen wir die Daten in einem Drittland nur beim Vorliegen der besonderen Voraussetzungen der Art. 44 ff. DSGVO verarbeiten. D.h. die Verarbeitung erfolgt z.B. auf Grundlage besonderer Garantien, wie der offiziell anerkannten Feststellung eines der EU entsprechenden Datenschutzniveaus (z.B. f&uuml;r die USA durch das &bdquo;Privacy Shield&ldquo;) oder Beachtung offiziell anerkannter spezieller vertraglicher Verpflichtungen (so genannte &bdquo;Standardvertragsklauseln&ldquo;).<br /><br /><strong><u>Rechte der betroffenen Personen<br /></u></strong>Sie haben das Recht, eine Best&auml;tigung dar&uuml;ber zu verlangen, ob betreffende Daten verarbeitet werden und auf Auskunft &uuml;ber diese Daten sowie auf weitere Informationen und Kopie der Daten entsprechend Art. 15 DSGVO.<br /><br />Sie haben entsprechend. Art. 16 DSGVO das Recht, die Vervollst&auml;ndigung der Sie betreffenden Daten oder die Berichtigung der Sie betreffenden unrichtigen Daten zu verlangen.<br /><br />Sie haben nach Ma&szlig;gabe des Art. 17 DSGVO das Recht zu verlangen, dass betreffende Daten unverz&uuml;glich gel&ouml;scht werden, bzw. alternativ nach Ma&szlig;gabe des Art. 18 DSGVO eine Einschr&auml;nkung der Verarbeitung der Daten zu verlangen.<br /><br />Sie haben das Recht zu verlangen, dass die Sie betreffenden Daten, die Sie uns bereitgestellt haben nach Ma&szlig;gabe des Art. 20 DSGVO zu erhalten und deren &Uuml;bermittlung an andere Verantwortliche zu fordern.<br /><br />Sie haben ferner gem. Art. 77 DSGVO das Recht, eine Beschwerde bei der zust&auml;ndigen Aufsichtsbeh&ouml;rde einzureichen.<br /><br /><strong><u>Widerrufsrecht</u></strong><br />Sie haben das Recht, erteilte Einwilligungen gem. Art. 7 Abs. 3 DSGVO mit Wirkung f&uuml;r die Zukunft zu widerrufen<br /><br /><strong><u>Widerspruchsrecht</u></strong><br />Sie k&ouml;nnen der k&uuml;nftigen Verarbeitung der Sie betreffenden Daten nach Ma&szlig;gabe des Art. 21 DSGVO jederzeit widersprechen. Der Widerspruch kann insbesondere gegen die Verarbeitung f&uuml;r Zwecke der Direktwerbung erfolgen.<br /><br /><strong><u>Cookies und Widerspruchsrecht bei Direktwerbung<br /></u></strong>Als &bdquo;Cookies&ldquo; werden kleine Dateien bezeichnet, die auf Rechnern der Nutzer gespeichert werden. Innerhalb der Cookies k&ouml;nnen unterschiedliche Angaben gespeichert werden. Ein Cookie dient prim&auml;r dazu, die Angaben zu einem Nutzer (bzw. dem Ger&auml;t auf dem das Cookie gespeichert ist) w&auml;hrend oder auch nach seinem Besuch innerhalb eines Onlineangebotes zu speichern. Als tempor&auml;re Cookies, bzw. &bdquo;Session-Cookies&ldquo; oder &bdquo;transiente Cookies&ldquo;, werden Cookies bezeichnet, die gel&ouml;scht werden, nachdem ein Nutzer ein Onlineangebot verl&auml;sst und seinen Browser schlie&szlig;t. In einem solchen Cookie kann z.B. der Inhalt eines Warenkorbs in einem Onlineshop oder ein Login-Status gespeichert werden. Als &bdquo;permanent&ldquo; oder &bdquo;persistent&ldquo; werden Cookies bezeichnet, die auch nach dem Schlie&szlig;en des Browsers gespeichert bleiben. So kann z.B. der Login-Status gespeichert werden, wenn die Nutzer diese nach mehreren Tagen aufsuchen. Ebenso k&ouml;nnen in einem solchen Cookie die Interessen der Nutzer gespeichert werden, die f&uuml;r Reichweitenmessung oder Marketingzwecke verwendet werden. Als &bdquo;Third-Party-Cookie&ldquo; werden Cookies bezeichnet, die von anderen Anbietern als dem Verantwortlichen, der das Onlineangebot betreibt, angeboten werden (andernfalls, wenn es nur dessen Cookies sind spricht man von &bdquo;First-Party Cookies&ldquo;).<br /><br />Wir k&ouml;nnen tempor&auml;re und permanente Cookies einsetzen und kl&auml;ren hier&uuml;ber im Rahmen unserer Datenschutzerkl&auml;rung auf.<br /><br />Falls die Nutzer nicht m&ouml;chten, dass Cookies auf ihrem Rechner gespeichert werden, werden sie gebeten die entsprechende Option in den Systemeinstellungen ihres Browsers zu deaktivieren. Gespeicherte Cookies k&ouml;nnen in den Systemeinstellungen des Browsers gel&ouml;scht werden. Der Ausschluss von Cookies kann zu Funktionseinschr&auml;nkungen dieses Onlineangebotes f&uuml;hren.<br /><br />Ein genereller Widerspruch gegen den Einsatz der zu Zwecken des Onlinemarketing eingesetzten Cookies kann bei einer Vielzahl der Dienste, vor allem im Fall des Trackings, &uuml;ber die US-amerikanische Seite http://www.aboutads.info/choices/oder die EU-Seite http://www.youronlinechoices.com/ erkl&auml;rt werden. Des Weiteren kann die Speicherung von Cookies mittels deren Abschaltung in den Einstellungen des Browsers erreicht werden. Bitte beachten Sie, dass dann gegebenenfalls nicht alle Funktionen dieses Onlineangebotes genutzt werden k&ouml;nnen.<br /><br /><strong><u>L&ouml;schung von Daten<br /></u></strong>Die von uns verarbeiteten Daten werden nach Ma&szlig;gabe der Art. 17 und 18 DSGVO gel&ouml;scht oder in ihrer Verarbeitung eingeschr&auml;nkt. Sofern nicht im Rahmen dieser Datenschutzerkl&auml;rung ausdr&uuml;cklich angegeben, werden die bei uns gespeicherten Daten gel&ouml;scht, sobald sie f&uuml;r ihre Zweckbestimmung nicht mehr erforderlich sind und der L&ouml;schung keine gesetzlichen Aufbewahrungspflichten entgegenstehen. Sofern die Daten nicht gel&ouml;scht werden, weil sie f&uuml;r andere und gesetzlich zul&auml;ssige Zwecke erforderlich sind, wird deren Verarbeitung eingeschr&auml;nkt. D.h. die Daten werden gesperrt und nicht f&uuml;r andere Zwecke verarbeitet. Das gilt z.B. f&uuml;r Daten, die aus handels- oder steuerrechtlichen Gr&uuml;nden aufbewahrt werden m&uuml;ssen.<br /><br />Nach gesetzlichen Vorgaben in Deutschland, erfolgt die Aufbewahrung insbesondere f&uuml;r 10 Jahre gem&auml;&szlig; &sect;&sect; 147 Abs. 1 AO, 257 Abs. 1 Nr. 1 und 4, Abs. 4 HGB (B&uuml;cher, Aufzeichnungen, Lageberichte, Buchungsbelege, Handelsb&uuml;cher, f&uuml;r Besteuerung relevanter Unterlagen, etc.) und 6 Jahre gem&auml;&szlig; &sect; 257 Abs. 1 Nr. 2 und 3, Abs. 4 HGB (Handelsbriefe).<br /><br /><strong><u>Der Gesundheitsvorsorge dienende Leistungen<br /></u></strong>Wir verarbeiten die Daten unserer Patienten und Interessenten und anderer Auftraggeber oder Vertragspartner (einheitlich bezeichnet als &bdquo;Patienten&ldquo;) entsprechend Art. 6 Abs. 1 lit. b) DSGVO, um ihnen gegen&uuml;ber unsere vertraglichen oder vorvertraglichen Leistungen zu erbringen. Die hierbei verarbeiteten Daten, die Art, der Umfang und der Zweck und die Erforderlichkeit ihrer Verarbeitung, bestimmen sich nach dem zugrundeliegenden Vertragsverh&auml;ltnis. Zu den verarbeiteten Daten geh&ouml;ren grunds&auml;tzlich Bestands- und Stammdaten der Patienten (z.B., Name, Adresse, etc.), als auch die Kontaktdaten (z.B., E-Mailadresse, Telefon, etc.), die Vertragsdaten (z.B., in Anspruch genommene Leistungen, erworbene Produkte, Kosten, Namen von Kontaktpersonen) und Zahlungsdaten (z.B., Bankverbindung, Zahlungshistorie, etc.).<br /><br />In Rahmen unserer Leistungen, k&ouml;nnen wir ferner besondere Kategorien von Daten gem. Art. 9 Abs. 1 DSGVO, hier insbesondere Angaben zur Gesundheit der Patienten, ggf. mit Bezug zu deren Sexualleben oder der sexuellen Orientierung, verarbeiten. Hierzu holen wir, sofern erforderlich, gem. Art. 6 Abs. 1 lit. a., Art. 7, Art. 9 Abs. 2 lit. a. DSGVO eine ausdr&uuml;ckliche Einwilligung der Patienten ein und verarbeiten die besonderen Kategorien von Daten ansonsten zu Zwecken der Gesundheitsvorsorge auf Grundlage des Art. 9 Abs. 2 lit h. DSGVO, &sect; 22 Abs. 1 Nr. 1 b. BDSG.<br /><br />Sofern f&uuml;r die Vertragserf&uuml;llung oder gesetzlich erforderlich, offenbaren oder &uuml;bermitteln wir die Daten der Patienten im Rahmen der Kommunikation mit medizinischen Fachkr&auml;ften, an der Vertragserf&uuml;llung erforderlicherweise oder typischerweise beteiligten Dritten, wie z.B. Labore, Abrechnungsstellen oder vergleichbare Dienstleister, sofern dies der Erbringung unserer Leistungen gem. Art. 6 Abs. 1 lit b. DSGVO dient, gesetzlich gem. Art. 6 Abs. 1 lit c. DSGVO vorgeschrieben ist, unseren Interessen oder denen der Patienten an einer effizienten und kosteng&uuml;nstigen Gesundheitsversorgung als berechtigtes Interesse gem. Art. 6 Abs. 1 lit f. DSGVO dient oder gem. Art. 6 Abs. 1 lit d. DSGVO notwendig ist. um lebenswichtige Interessen der Patienten oder einer anderen nat&uuml;rlichen Person zu sch&uuml;tzen oder im Rahmen einer Einwilligung gem. Art. 6 Abs. 1 lit. a., Art. 7 DSGVO.<br /><br />Die L&ouml;schung der Daten erfolgt, wenn die Daten zur Erf&uuml;llung vertraglicher oder gesetzlicher F&uuml;rsorgepflichten sowie Umgang mit etwaigen Gew&auml;hrleistungs- und vergleichbaren Pflichten nicht mehr erforderlich ist, wobei die Erforderlichkeit der Aufbewahrung der Daten alle drei Jahre &uuml;berpr&uuml;ft wird; im &Uuml;brigen gelten die gesetzlichen Aufbewahrungspflichten.<br /><br /><strong><u>Therapeutische Leistungen und Coaching<br /></u></strong>Wir verarbeiten die Daten unserer Klienten und Interessenten und anderer Auftraggeber oder Vertragspartner (einheitlich bezeichnet als &bdquo;Klienten&ldquo;) entsprechend Art. 6 Abs. 1 lit. b) DSGVO, um ihnen gegen&uuml;ber unsere vertraglichen oder vorvertraglichen Leistungen zu erbringen. Die hierbei verarbeiteten Daten, die Art, der Umfang und der Zweck und die Erforderlichkeit ihrer Verarbeitung, bestimmen sich nach dem zugrundeliegenden Vertragsverh&auml;ltnis. Zu den verarbeiteten Daten geh&ouml;ren grunds&auml;tzlich Bestands- und Stammdaten der Klienten (z.B., Name, Adresse, etc.), als auch die Kontaktdaten (z.B., E-Mailadresse, Telefon, etc.), die Vertragsdaten (z.B., in Anspruch genommene Leistungen, Honorare, Namen von Kontaktpersonen, etc.) und Zahlungsdaten (z.B., Bankverbindung, Zahlungshistorie, etc.).<br /><br />Im Rahmen unserer Leistungen, k&ouml;nnen wir ferner besondere Kategorien von Daten gem. Art. 9 Abs. 1 DSGVO, insbesondere Angaben zur Gesundheit der Klienten, ggf. mit Bezug zu deren Sexualleben oder der sexuellen Orientierung, ethnischer Herkunft oder religi&ouml;sen oder weltanschaulichen &Uuml;berzeugungen, verarbeiten. Hierzu holen wir, sofern erforderlich, gem. Art. 6 Abs. 1 lit. a., Art. 7, Art. 9 Abs. 2 lit. a. DSGVO eine ausdr&uuml;ckliche Einwilligung der Klienten ein und verarbeiten die besonderen Kategorien von Daten ansonsten zu Zwecken der Gesundheitsvorsorge auf Grundlage des Art. 9 Abs. 2 lit h. DSGVO, &sect; 22 Abs. 1 Nr. 1 b. BDSG.<br /><br />Sofern f&uuml;r die Vertragserf&uuml;llung oder gesetzlich erforderlich, offenbaren oder &uuml;bermitteln wir die Daten der Klienten im Rahmen der Kommunikation mit anderen Fachkr&auml;ften, an der Vertragserf&uuml;llung erforderlicherweise oder typischerweise beteiligten Dritten, wie z.B. Abrechnungsstellen oder vergleichbare Dienstleister, sofern dies der Erbringung unserer Leistungen gem. Art. 6 Abs. 1 lit b. DSGVO dient, gesetzlich gem. Art. 6 Abs. 1 lit c. DSGVO vorgeschrieben ist, unseren Interessen oder denen der Klienten an einer effizienten und kosteng&uuml;nstigen Gesundheitsversorgung als berechtigtes Interesse gem. Art. 6 Abs. 1 lit f. DSGVO dient oder gem. Art. 6 Abs. 1 lit d. DSGVO notwendig ist. um lebenswichtige Interessen der Klienten oder einer anderen nat&uuml;rlichen Person zu sch&uuml;tzen oder im Rahmen einer Einwilligung gem. Art. 6 Abs. 1 lit. a., Art. 7 DSGVO.<br /><br />Die L&ouml;schung der Daten erfolgt, wenn die Daten zur Erf&uuml;llung vertraglicher oder gesetzlicher F&uuml;rsorgepflichten sowie Umgang mit etwaigen Gew&auml;hrleistungs- und vergleichbaren Pflichten nicht mehr erforderlich ist, wobei die Erforderlichkeit der Aufbewahrung der Daten alle drei Jahre &uuml;berpr&uuml;ft wird; im &Uuml;brigen gelten die gesetzlichen Aufbewahrungspflichten.<br /><br /><strong><u>Administration, Finanzbuchhaltung, B&uuml;roorganisation, Kontaktverwaltung<br /></u></strong>Wir verarbeiten Daten im Rahmen von Verwaltungsaufgaben sowie Organisation unseres Betriebs, Finanzbuchhaltung und Befolgung der gesetzlichen Pflichten, wie z.B. der Archivierung. Hierbei verarbeiten wir dieselben Daten, die wir im Rahmen der Erbringung unserer vertraglichen Leistungen verarbeiten. Die Verarbeitungsgrundlagen sind Art. 6 Abs. 1 lit. c. DSGVO, Art. 6 Abs. 1 lit. f. DSGVO. Von der Verarbeitung sind Kunden, Interessenten, Gesch&auml;ftspartner und Websitebesucher betroffen. Der Zweck und unser Interesse an der Verarbeitung liegt in der Administration, Finanzbuchhaltung, B&uuml;roorganisation, Archivierung von Daten, also Aufgaben die der Aufrechterhaltung unserer Gesch&auml;ftst&auml;tigkeiten, Wahrnehmung unserer Aufgaben und Erbringung unserer Leistungen dienen. Die L&ouml;schung der Daten im Hinblick auf vertragliche Leistungen und die vertragliche Kommunikation entspricht den, bei diesen Verarbeitungst&auml;tigkeiten genannten Angaben.<br /><br />Wir offenbaren oder &uuml;bermitteln hierbei Daten an die Finanzverwaltung, Berater, wie z.B., Steuerberater oder Wirtschaftspr&uuml;fer sowie weitere Geb&uuml;hrenstellen und Zahlungsdienstleister.<br /><br />Ferner speichern wir auf Grundlage unserer betriebswirtschaftlichen Interessen Angaben zu Lieferanten, Veranstaltern und sonstigen Gesch&auml;ftspartnern, z.B. zwecks sp&auml;terer Kontaktaufnahme. Diese mehrheitlich unternehmensbezogenen Daten, speichern wir grunds&auml;tzlich dauerhaft.<br /><br /><strong><u>Kontaktaufnahme</u></strong><br />Bei der Kontaktaufnahme mit uns (z.B. per Kontaktformular, E-Mail, Telefon oder via sozialer Medien) werden die Angaben des Nutzers zur Bearbeitung der Kontaktanfrage und deren Abwicklung gem. Art. 6 Abs. 1 lit. b. (im Rahmen vertraglicher-/vorvertraglicher Beziehungen), Art. 6 Abs. 1 lit. f. (andere Anfragen) DSGVO verarbeitet.. Die Angaben der Nutzer k&ouml;nnen in einem Customer-Relationship-Management System (\"CRM System\") oder vergleichbarer Anfragenorganisation gespeichert werden.<br /><br />Wir l&ouml;schen die Anfragen, sofern diese nicht mehr erforderlich sind. Wir &uuml;berpr&uuml;fen die Erforderlichkeit alle zwei Jahre; Ferner gelten die gesetzlichen Archivierungspflichten.<br /><br /><strong><u>Google Maps<br /></u></strong>Wir binden die Landkarten des Dienstes &ldquo;Google Maps&rdquo; des Anbieters Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA, ein. Zu den verarbeiteten Daten k&ouml;nnen insbesondere IP-Adressen und Standortdaten der Nutzer geh&ouml;ren, die jedoch nicht ohne deren Einwilligung (im Regelfall im Rahmen der Einstellungen ihrer Mobilger&auml;te vollzogen), erhoben werden. Die Daten k&ouml;nnen in den USA verarbeitet werden. Datenschutzerkl&auml;rung: https://www.google.com/policies/privacy/, Opt-Out:&nbsp;<a href=\"https://adssettings.google.com/authenticated\">https://adssettings.google.com/authenticated</a>.<br /><br />Erstellt mit Datenschutz-Generator.de von RA Dr. Thomas Schwenke</div>\n</div>\n</div>\n</div>", "_mby": "5c78dbb16435630838000192", "_by": "5c78dbb16435630838000192", "_o": 0, "_modified": 1552549390, "_created": 1552549390, "_id": "5c8a060e663436173b000267", "children": [] }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$http.get(this.$store.getters.serviceClient().getCollectionUrl('contentGdpr')).then(function (response) {
      if (response.ok) {
        console.log(response.body.entries);
        _this.$data.collection = response.body.entries;
      }
    }).catch(function (error) {
      console.log(error);
    });
  },

  props: [],
  computed: {},
  methods: {}
});

/***/ }),

/***/ "6yGo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"latest-posts",attrs:{"id":_vm.menuItem.anchor}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-1"},[_vm._v(" ")]),_vm._v(" "),_vm._l((_vm.cards),function(card){return _c('div',{key:card.name,staticClass:"col-12 mb-30"},[_c('div',{staticClass:"blog-card",attrs:{"id":card.anchorName}},[_c('div',{staticClass:"blog-text"},[_c('h3',{staticClass:"dark bold mb-15",staticStyle:{"word-break":"normal"}},[_vm._v(_vm._s(card.title))]),_vm._v(" "),_c('div',{staticClass:"dark light opas mb-30",domProps:{"innerHTML":_vm._s(card.text)}}),_vm._v(" "),_c('a',{staticClass:"button button-2 mr-1",attrs:{"href":"#","data-toggle":"modal","data-target":".wideCardDetailModal"},on:{"click":function($event){return _vm.setModalContent(card, false)}}},[_vm._v(_vm._s(card.button1Text)),_c('i',{staticClass:"fas fa-chevron-right"})]),_vm._v(" "),_c('a',{staticClass:"button button-2",attrs:{"href":"#","data-toggle":"modal","data-target":".wideCardDetailModal"},on:{"click":function($event){return _vm.setModalContent(card, true)}}},[_vm._v(_vm._s(card.button2Text)),_c('i',{staticClass:"fas fa-chevron-right"})])])])])})],2)]),_vm._v(" "),_c('div',{staticClass:"modal fade wideCardDetailModal",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"myLargeModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[(!_vm.modal.showAlternative)?_c('h5',{staticClass:"modal-title",attrs:{"id":"modalTitle"}},[_vm._v(_vm._s(_vm.modal.title))]):_c('h5',{staticClass:"modal-title",attrs:{"id":"modalTitle"}},[_vm._v(_vm._s(_vm.modal.alternativeTitle))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),(!_vm.modal.showAlternative)?_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"px-4 py-2",domProps:{"innerHTML":_vm._s(_vm.modal.detailText)}})]):_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"px-4 py-2",domProps:{"innerHTML":_vm._s(_vm.modal.alternativeDetailText)}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[(!_vm.modal.showAlternative)?_c('button',{staticClass:"button button-2",attrs:{"type":"button"},on:{"click":_vm.toggleModalViewAndScroll}},[_vm._v(_vm._s(_vm.modal.alternativeTitle)+" "),_c('i',{staticClass:"fas fa-chevron-right"})]):_vm._e(),_vm._v(" "),(_vm.modal.showAlternative)?_c('button',{staticClass:"button button-2",attrs:{"type":"button"},on:{"click":_vm.toggleModalViewAndScroll}},[_vm._v(_vm._s(_vm.modal.title)+" "),_c('i',{staticClass:"fas fa-chevron-right"})]):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7OMd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParallaxPage_vue__ = __webpack_require__("pXU9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b30a92d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParallaxPage_vue__ = __webpack_require__("tV5o");
function injectStyle (ssrContext) {
  __webpack_require__("LUdc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParallaxPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b30a92d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParallaxPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/assets/img/logo.a38f1af.png";

/***/ }),

/***/ "7hJm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery_parallax_js__ = __webpack_require__("q/JL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery_parallax_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery_parallax_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      collection: { 'title': 'Herzlich Willkommen auf den Seiten der Praxis Nicolas Mandt', 'subTitle': 'tiefenpsychologisch fundierte Psychotherapie für Kinder, Jugendliche und junge Erwachsene', 'backgroundImage': { 'path': '/cockpit/storage/uploads/2019/03/01/5c7909eec0412banner.jpg' }, '_mby': '5c78dbb16435630838000192', '_by': '5c78dbb16435630838000192', '_modified': 1551441773, '_created': 1551436280, '_id': '5c7909f8643563083800016d', 'arrowTarget': '/#service' }
    };
  },

  props: ['menuItem'],
  computed: {
    baseUrl: function baseUrl() {
      return this.$store.getters.baseUrl();
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$http.get(this.$store.getters.serviceClient().getCollectionUrl(this.$props.menuItem.collection)).then(function (response) {
      if (response.ok) {
        console.log(response.body.entries);
        _this.$data.collection = response.body.entries[0];
      }
    }).catch(function (error) {
      console.log(error);
    });

    // Parallax
    $('.parallax-window').parallax({
      zIndex: -100
    });
  },

  methods: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "8Z0S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      formUrl: 'https://www.praxismandt.de/contactform',
      captchaId: null,
      busy: false,
      form: {
        accept: false,
        id: null,
        value: null,
        name: null,
        email: null,
        message: null,
        phone: null
      },
      alert: {
        show: false,
        type: 'alert-info',
        header: null,
        message: null
      }
    };
  },

  props: ['menuItem'],
  computed: {},
  mounted: function mounted() {
    this.newCaptcha();
  },

  methods: {
    newCaptcha: function newCaptcha() {
      var _this = this;

      this.$http.get(this.$data.formUrl + '/captchaid.php').then(function (response) {
        if (response.ok) {
          console.log(response.body.entries);
          _this.$data.captchaId = response.body.captchaId;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    showAlert: function showAlert(header, message, type, timeout) {
      this.$data.alert.type = type;
      this.$data.alert.message = message;
      this.$data.alert.header = header;
      this.$data.alert.show = true;

      var that = this;
      if (timeout) {
        setTimeout(function () {
          that.$data.alert.show = false;
        }, timeout);
      }
    },
    sendMail: function sendMail() {
      var _this2 = this;

      this.$data.busy = true;

      this.$data.form.id = this.$data.captchaId;
      this.$http.post(this.$data.formUrl + '/formtarget.php', this.$data.form, {
        emulateJSON: true
      }).then(function (response) {
        _this2.$data.busy = false;
        if (response.ok) {
          console.log('okay');
          _this2.showAlert('Gesendet!', 'Vielen Dank für Ihre Anfrage.', 'alert-success', null);
        } else {
          console.log(response);
          _this2.showAlert('Fehler!', 'Die Anfrage konnte nicht gesendet werden.', 'alert-danger', 5000);
        }
      }).catch(function (error) {
        _this2.$data.busy = false;
        console.log(error);
        if (error.status === 403) {
          _this2.showAlert('Noch nicht ganz...', 'Der Text passt nicht zum Prüfbild.', 'alert-warning', 5000);
          console.log('Captcha not solved');
        } else if (error.status === 401) {
          _this2.showAlert('Noch nicht ganz...', 'Bitte füllen Sie alle Felder aus.', 'alert-warning', 5000);
        } else if (error.status === 400) {
          _this2.showAlert('Captcha abgelaufen', 'Das Formular wurde zu lange nicht benutzt.', 'alert-warning', 5000);
        } else {
          _this2.showAlert('Fehler', 'Die Anfrage konnte nicht gesendet werden.', 'alert-danger', 5000);
          console.log('error');
        }
      });
    }
  }
});

/***/ }),

/***/ "8kLe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8mQd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__ = __webpack_require__("5yYN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56e18f81_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__ = __webpack_require__("YX7S");
function injectStyle (ssrContext) {
  __webpack_require__("x29w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56e18f81"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56e18f81_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AwAH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"p-90-0-60",attrs:{"id":_vm.menuItem.anchor}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-30 align-self-center"},[_c('h2',{staticClass:"light dark mb-30"},[_vm._v(_vm._s(_vm.menuItem.name)+" "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.menuItem.nameBold))])])])])]),_vm._v(" "),(!_vm.showDummy)?_c('div',[_c('iframe',{attrs:{"src":_vm.collection.googleMapsUrl,"width":"100%","height":"600px","frameborder":"0","allowfullscreen":""}})]):_c('div',{staticClass:"mapDummy",style:('background-image: url(\'' + _vm.baseUrl + _vm.collection.placeholderImage.path + '\');'),on:{"click":function($event){return _vm.showMap()}}},[_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"main-title text-center p-5"},[_c('h1',{staticClass:"light mb-15"},[_vm._v(_vm._s(_vm.collection.disclaimerText))]),_vm._v(" "),_c('h3',{staticClass:"light opas mb-30"},[_vm._v(_vm._s(_vm.collection.disclaimerSubText))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CHQz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      collection: [],
      selectedArticle: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$http.get(this.$store.getters.serviceClient().getCollectionUrl('contentBlog')).then(function (response) {
      if (response.ok) {
        console.log(response.body.entries);
        _this.$data.collection = response.body.entries;

        if (_this.$route.query.id) {
          var searchId = _this.$route.query.id;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.$data.collection), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var article = _step.value;

              if (article._id == searchId) {
                _this.$data.selectedArticle = article;
                break;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      }
    }).catch(function (error) {
      console.log(error);
    });
  },

  props: [],
  computed: {
    baseUrl: function baseUrl() {
      return this.$store.getters.baseUrl();
    }
  },
  methods: {}
});

/***/ }),

/***/ "COAt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('nav',{staticClass:"navbar navbar-expand-xl bg-scroll",attrs:{"id":"navigation"}},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"/#home"}},[_c('span',[(_vm.settings.logo)?_c('img',{attrs:{"src":_vm.baseUrl + _vm.settings.logo.path,"alt":"logo","height":"50px"}}):_vm._e()]),_c('span',[_vm._v(_vm._s(_vm.settings.pageName))])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav ml-auto"},[_vm._l((_vm.menu),function(item){return [(item.visible)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":item.link,"data-anchor":'#' + item.anchor},on:{"click":_vm.scrollTo}},[_vm._v(_vm._s(item.menuText))])]):_vm._e()]}),_vm._v(" "),(_vm.subMenu)?_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"id":"navbarDropdown","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(" Mehr")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",staticStyle:{"right":"0","left":"auto"},attrs:{"aria-labelledby":"navbarDropdown"}},[_vm._l((_vm.subMenu),function(subitem){return [(subitem.visible)?_c('a',{staticClass:"dropdown-item",attrs:{"href":subitem.link}},[_vm._v(_vm._s(subitem.menuText))]):_vm._e()]})],2)]):_vm._e()],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"burger-menu"},[_c('span',{staticClass:"burger"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DE2e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"parallax-window",attrs:{"id":_vm.menuItem.anchor,"data-parallax":"scroll","data-image-src":"/static/img/banner.jpg"}},[_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"titleContainer"},[_c('div',{staticClass:"main-title text-center"},[_c('h1',{staticClass:"light mb-15"},[_vm._v(_vm._s(_vm.collection.title))]),_vm._v(" "),_c('h3',{staticClass:"light opas mb-30"},[_vm._v(_vm._s(_vm.collection.subTitle))]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button button-3 mr-1",attrs:{"href":"/#infoEltern","data-anchor":"#infoEltern"}},[_vm._v("Für"),_c('br'),_vm._v("Eltern"),_c('i',{staticClass:"fas fa-chevron-right hidemobile"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button button-3 mr-1",attrs:{"href":"/#infoJugendliche","data-anchor":"#infoJugendliche"}},[_vm._v("Für"),_c('br'),_vm._v("Jugendliche"),_c('i',{staticClass:"fas fa-chevron-right hidemobile"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ddac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"latest-posts p-90-0-60",attrs:{"id":_vm.menuItem.anchor}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section-title mb-60"},[_c('h2',{staticClass:"light dark mb-30"},[_vm._v(_vm._s(_vm.menuItem.name)+" "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.menuItem.nameBold))])])]),_vm._v(" "),_vm._l((_vm.texts),function(text){return _c('div',{staticClass:"row"},[(text.imageLeft)?[_c('div',{staticClass:"col-12 col-lg-4 mb-30 d-flex flex-wrap align-items-center"},[_c('img',{staticClass:"img-fluid",staticStyle:{"width":"100%"},attrs:{"src":_vm.baseUrl + text.image.path}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-8 mb-30"},[_c('p',{staticClass:"dark",domProps:{"innerHTML":_vm._s(text.content)}})])]:[_c('div',{staticClass:"col-12 col-lg-8 mb-30"},[_c('p',{staticClass:"dark",domProps:{"innerHTML":_vm._s(text.content)}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4 mb-30 d-flex flex-wrap align-items-center"},[_c('img',{staticClass:"img-fluid",staticStyle:{"width":"100%"},attrs:{"src":_vm.baseUrl + text.image.path}})])]],2)})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DiUE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var markdown = __webpack_require__("+sNg").markdown;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      texts: [{ 'text': 'Meine Arbeitsweise\nGemeinsam machen wir uns auf eine Art Expedition, eine Entdeckungsreise ins Unbewusste. Ich nenne das "Seelenarchäologie". Damit das gelingen kann, muss sich eine tragfähige, vertrauensvolle und authentische Beziehung entwickeln. Nur dann können sich innerhalb dieser Beziehung die inneren, frühen Erfahrungen zeigen und bearbeiten lassen.\n', 'image': { 'path': '/cockpit/storage/uploads/2019/03/06/5c801ab0a79eeNicolas_Mandt_L1008742.jpg' }, 'imageLeft': true, 'content': '<h3 style="text-align: justify;">Meine<strong> Arbeitsweise</strong></h3>\n<p style="text-align: justify;">&nbsp;</p>\n<p style="text-align: justify;">Gemeinsam machen wir uns auf eine Art Expedition, eine Entdeckungsreise ins Unbewusste. Ich nenne das "Seelenarch&auml;ologie". Damit das gelingen kann, muss sich eine tragf&auml;hige, vertrauensvolle und authentische Beziehung entwickeln. Nur dann k&ouml;nnen sich innerhalb dieser Beziehung die inneren, fr&uuml;hen Erfahrungen zeigen und bearbeiten lassen.</p>\n<p style="text-align: justify;">Jede Beziehung ist anders - und der Beziehungsaufbau ben&ouml;tigt Zeit. Manchmal reichen 25 Sitzungen in w&ouml;chentlichem Abstand, meistens jedoch braucht es mehr Zeit, 50 Sitzungen und mehr. Es gibt kein Rezept f&uuml;r eine erfolgreiche Psychotherapie, da jede Behandlung wie die Seele und jeder Mensch einzigartig und besonders ist.</p>\n<p style="text-align: justify;">&nbsp;</p>', '_mby': '5c78dbb16435630838000192', '_by': '5c78dbb16435630838000192', '_o': 0, '_modified': 1552817250, '_created': 1552816036, '_id': '5c8e17a466343651460000f8', '_pid': null, 'children': [] }, { 'text': '**Meine Arbeitsweise - "Seelenarchäologie**"\n\nGemeinsam machen wir uns auf eine Art Expedition, eine Entdeckungsreise ins Unbewusste. Damit das gelingen kann, muss sich eine tragfähige, vertrauensvolle und authentische Beziehung entwickeln. Nur dann können sich innerhalb dieser Beziehung die inneren, frühen Erfahrungen zeigen und bearbeiten lassen. \n\nJede Beziehung ist anders - und der Beziehungsaufbau benötigt Zeit. Manchmal reichen 25 Sitzungen in wöchentlichem Abstand, meistens jedoch braucht es mehr Zeit, 50 Sitzungen und mehr. Es gibt kein Rezept für eine erfolgreiche Psychotherapie, da jede Behandlung wie die Seele und jeder Mensch einzigartig und besonders ist.\n\nWir entwickeln und beschließen daher gemeinsam Ziele für die Therapie (Was soll sich ändern?) und Du bestimmst bzw. Sie bestimmen mit, was in den Therapiesitzungen passiert, was wir machen, worüber gesprochen  wird - und worüber (noch) nicht. Mitentscheiden, was in den Sitzungen passiert, bedeutet: Es können je nach Alter und Vorliebe unterschiedliche Methoden zum Einsatz kommen, z.B.  Gespräche, Sandspieltherapie, freies Spiel, künstlerisches Gestalten, Malen, Musik… Die Methoden sind so vielfältig und facettenreich wie die Seele.\n\nMehr zum **therapeutischen Sandspiel**', 'image': { 'path': '/cockpit/storage/uploads/2019/03/06/5c801ab0208a2Nicolas_Mandt__75A5361.jpg', 'title': 'Nicolas_Mandt__75A5361.jpg', 'mime': 'image/jpeg', 'description': '', 'tags': [], 'size': 33258, 'image': true, 'video': false, 'audio': false, 'archive': false, 'document': false, 'code': false, 'created': 1551899312, 'modified': 1551899312, '_by': '5c78dbb16435630838000192', 'width': 600, 'height': 400, 'colors': ['#c3c0bf', '#252226', '#6b4f3e', '#7e6a5c', '#7c7473'], 'folder': '', '_id': '5c801ab06435632d34000157' }, 'imageLeft': false, '_mby': '5c78dbb16435630838000192', '_by': '5c78dbb16435630838000192', '_modified': 1552817101, '_created': 1551899363, '_id': '5c801ae36435632d3400019b', '_pid': null, '_o': 1, 'content': '<p style="text-align: justify;">Wir entwickeln und beschlie&szlig;en daher gemeinsam die <strong>Ziele</strong> f&uuml;r die Therapie (Was soll sich &auml;ndern?) und Du bestimmst bzw. Sie bestimmen mit, was in den Therapiesitzungen passiert, was wir machen, wor&uuml;ber gesprochen wird - und wor&uuml;ber (noch) nicht. Mitentscheiden, was in den Sitzungen passiert, bedeutet: Es k&ouml;nnen je nach Alter und Vorliebe unterschiedliche <strong>Methoden</strong> zum Einsatz kommen, z.B. Gespr&auml;che, Sandspieltherapie, freies Spiel, k&uuml;nstlerisches Gestalten, Malen, Musik&hellip; Die Methoden sind so vielf&auml;ltig und facettenreich wie die Seele.</p>\n<p style="text-align: justify;">&nbsp;</p>\n<p style="text-align: justify;">Im <strong>therapeutischen Sandspiel</strong> z.B. bietet der Sand eine Projektionsfl&auml;che, auf der sich die unbewussten Anteile der Pers&ouml;nlichkeit zeigen k&ouml;nnen. Die Gestaltung des Sandes und der Einsatz von Figuren und Symbolen erfolgt nicht beliebig oder zuf&auml;llig, sondern folgt einer bewussten oder unbewussten, intuitiven Entscheidung. Dadurch k&ouml;nnen sich im Sandspiel innere Vorg&auml;nge und Facetten zeigen, die sonst dem Bewusstsein nur schwer zug&auml;nglich gemacht werden k&ouml;nnen.&nbsp;</p>\n<p style="text-align: justify;">&nbsp;</p>', 'children': [] }, { 'text': '### Vita\n* 1985 geboren in Köln\n* 2012 Abschluss Diplom-Pädagogik (Universität Bamberg)\n* 2014 - 2018 Anstellung in der kinder- und jugendpsychiatrischen Praxis Langner (Köln-Ehrenfeld)\n* 2015 - 2018 psychotherapeutische Tätigkeit an der Institutsambulanz der Köln-Bonner Akademie für Psychotherapie (Bonn)\n* 2018 Approbation als Kinder- und Jugendlichenpsychotherapeut\n* 2018 Eintrag ins Arztregister\n* 2018 Berater in Erziehungs- und Familienberatungsstelle Düsseldorf-Wersten\n* 2019 Niederlassung in eigener Praxis in Köln', 'image': { 'path': '/cockpit/storage/uploads/2019/03/17/5c8e18e7a424dNicolas_Mandt_Nicolas_Mandt_L1008806.jpg', 'title': 'Nicolas_Mandt_L1008806.jpg', 'mime': 'image/jpeg', 'description': '', 'tags': [], 'size': 35135, 'image': true, 'video': false, 'audio': false, 'archive': false, 'document': false, 'code': false, 'created': 1551899313, 'modified': 1551899313, '_by': '5c78dbb16435630838000192', 'width': 600, 'height': 401, 'colors': ['#bcbcb4', '#1e212a', '#5e4e47', '#6e6d65', '#745e43'], 'folder': '', '_id': '5c801ab26435632d340002c8' }, 'imageLeft': true, '_mby': '5c78dbb16435630838000192', '_by': '5c78dbb16435630838000192', '_modified': 1552817258, '_created': 1551899161, '_id': '5c801a196435632d34000261', '_pid': null, '_o': 2, 'content': '<h3>Meine <strong>Vita</strong></h3>\n<p style="text-align: justify;">&nbsp;</p>\n<p style="text-align: justify;">1985 geboren in K&ouml;ln<br />2012 Abschluss Diplom-P&auml;dagogik (Universit&auml;t Bamberg)<br />2014-2018 Anstellung in der kinder- und jugendpsychiatrischen Praxis Langner (K&ouml;ln-Ehrenfeld)<br />2015-2018 psychotherapeutische T&auml;tigkeit an der Institutsambulanz der K&ouml;ln-Bonner Akademie f&uuml;r Psychotherapie (Bonn)<br />2018 Approbation als Kinder- und Jugendlichenpsychotherapeut<br />2018 Eintrag ins Arztregister<br />2018 Anstellung in der Caritas Erziehungs- und Familienberatungsstelle D&uuml;sseldorf-Wersten<br />2019 Niederlassung in eigener Praxis in K&ouml;ln</p>', 'children': [] }]
    };
  },

  props: ['menuItem'],
  computed: {
    baseUrl: function baseUrl() {
      return this.$store.getters.baseUrl();
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$http.get(this.$store.getters.serviceClient().getCollectionUrl(this.$props.menuItem.collection)).then(function (response) {
      if (response.ok) {
        console.log(response.body.entries);
        _this.$data.texts = response.body.entries;
      }
    }).catch(function (error) {
      console.log(error);
    });
  },

  methods: {
    parseMarkdown: function parseMarkdown(md) {
      return markdown.toHTML(md);
    }
  }
});

/***/ }),

/***/ "EMFf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__ = __webpack_require__("gjb/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef1d8b3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__ = __webpack_require__("zk0i");
function injectStyle (ssrContext) {
  __webpack_require__("GFEB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ef1d8b3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef1d8b3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fb3H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      cards: [{ 'name': 'Kinder- & Jugendlichenpsychotherapie', 'description': '<p>F&uuml;r Privatversicherte und Selbstzahler<br />tiefenpsychologisch fundierte Psychotherapie f&uuml;r Kinder, Jugendliche, junge Erwachsene (bis 21 Jahren)</p>', 'detailText': '<p style="text-align: justify;"><strong>Tiefenpsychologisch fundierte Psychotherapie</strong> ist eine Heilbehandlung, bei der die st&ouml;renden Symptome und das "Problemverhalten" auf die tieferliegenden Ursachen hin untersucht werden.</p>\n<p style="text-align: justify;">&nbsp;</p>\n<p style="text-align: justify;">Sinnbildlich geht es in der Therapie darum, die Sprache des Unbewussten, die Sprache des Symptoms und den Nutzen und Sinn der Symptome, die &bdquo;<strong>Psycho-Logik</strong>&ldquo; zu verstehen. Erst dann reduzieren sich Symptome nachhaltig und seelische Reifeprozesse k&ouml;nnen in Gang kommen.</p>\n<p style="text-align: justify;">&nbsp;</p>\n<p style="text-align: justify;">Diese Therapieform strebt also nicht die "blinde" Beseitigung von Symptomen an, sondern wir versuchen im Rahmen dieser intensiven, umfassenden Arbeit gemeinsam zu verstehen, f&uuml;r welches (unbewusstes) Problem die Symptome eine (wenn auch unangenehme) L&ouml;sung sind. Dieses ursachenorientierte Verstehen zusammen mit dem Bearbeiten alter, fr&uuml;h gelernter Erfahrungen von Beziehungen im Rahmen der tragf&auml;higen, authentischen therapeutischen Beziehung f&uuml;hrt zu einer nachhaltigen Ver&auml;nderung und einem best&auml;ndigen Symptomr&uuml;ckgang.</p>\n<p style="text-align: justify;">&nbsp;</p>\n<p style="text-align: justify;">siehe auch meine <strong>Arbeitsweise</strong></p>', 'priceText': '<p>Die Kosten f&uuml;r Psychotherapie werden von allen privaten Krankenkassen sowie von der Beihilfekasse &uuml;bernommen. Privatversicherte und Selbstzahler erhalten eine Rechnung nach der Geb&uuml;hrenordnung f&uuml;r Psychotherapeuten (GOP) mit 2,3-fachem Satz.&nbsp;</p>\n<p>&nbsp;</p>\n<ul>\n<li><strong>psychotherapeutische Sitzungen: 92,50 &euro;</strong>&nbsp;<br />Tiefenpsychologisch fundierte Psychotherapie und probatorische Sitzungen (Einzel), 50 Minuten, GOP-Ziffer 861</li>\n</ul>\n<p>Dar&uuml;ber hinaus fallen im Rahmen bei Einleitung einer Psychotherapie folgende Positionen an:</p>\n<p>&nbsp;</p>\n<ul>\n<li><strong>biografische Anamnese: 123,34 &euro;</strong><br />Erhebung einer biografische Anamnese unter neurosenpsychologischen Gesichtspunkten&nbsp;zur Einleitung und Indikationsstellung einer tiefenpsychologisch fundierten Psychotherapie,&nbsp;GOP-Ziffer 860:&nbsp;</li>\n</ul>\n<p>&nbsp;</p>\n<ul>\n<li><strong>Antrag bei Einleitung einer Psychotherapie: 53,62 &euro;</strong><br />Antragsstellung und Einleitung einer tiefenpsychologisch fundierten Psychotherapie (einschlie&szlig;lich Gutachterverfahren),&nbsp;GOP-Ziffer 808</li>\n</ul>\n<p>&nbsp;</p>\n<p>Im Rahmen der Probatorik k&ouml;nnen zudem nach Absprache bei Durchf&uuml;hrung von Testverfahren weitere Kosten anfallen (siehe <strong>Psychodiagnostik</strong>).</p>', 'image': { 'path': '/cockpit/storage/uploads/2019/03/06/5c800eff7fba3therapie.jpg' }, 'columnWidth': '1/3', '_mby': '5c78dbb16435630838000192', '_by': '5c78dbb16435630838000192', '_o': 0, '_modified': 1552412034, '_created': 1551896294, '_id': '5c800ee66435632d34000096', 'children': [] }, { 'name': 'Psychodiagnostik', 'description': '<p>F&uuml;r Privatversicherte und Selbstzahler</p>\n<p>individuell angepasste Psychodiagnostik bei unterschiedlichsten psychischen Fragestellungen</p>', 'detailText': '<p><strong>Psychodiagnostik</strong> bedeutet Feststellen und Bestimmen von seelischen Krankheiten.&nbsp;Gemeinsam helfe ich Dir und Ihnen dabei, die individuelle Problemsituation zu beleuchten und einzuordnen. Es geht darum herauszufinden, was genau das Problem ist, Hypothesen f&uuml;r m&ouml;gliche Ursachen zu bilden und eine Empfehlung f&uuml;r eine m&ouml;gliche Behandlung zu entwickeln.</p>\n<p>&nbsp;</p>\n<p>Ein <strong>Beispiel</strong>: Schulleistungsprobleme k&ouml;nnen durch schulische &Uuml;ber- und auch Unterforderung, Teilleistungsst&ouml;rungen (wie Lese-Rechtschreibst&ouml;rung), emotionale Belastung, Mobbing, famili&auml;re Konflikte oder "einfach" pers&ouml;nlichen Reifungsthemen entstehen. Dem gilt es auf den Grund zu gehen, um damit es bald wieder besser wird.</p>\n<p>&nbsp;</p>\n<p>Der <strong>typische Ablauf</strong> sieht wie folgt aus: Nach einem Erstgespr&auml;ch planen wir die Diagnostikphase. Darin lenen wir uns kennen und ich nehme - auch mithilfe geeigneter Testverfahren (wie projektive Verfahren, Frageb&ouml;gen, bei Verdacht auf Teilleistungsst&ouml;rungen auch Intelligenztest) - eine diagnostische Einsch&auml;tzung vor. Zus&auml;tzlich findet ein Gespr&auml;ch mit den Eltern bzw. Bezugspersonen statt, um die biografische Anamnese, d.h. Lebensgeschichte, zu erfassen. Abschlie&szlig;end besprechen wir die Ergebnisse und Empfehlungen. Falls tiefenpsychologisch fundierte Psychotherapie nicht &bdquo;das Richtige&ldquo; sein sollte, begleite und berate ich Dich und Sie bei der Suche nach passenden Hilfeangeboten.</p>\n<p>&nbsp;</p>\n<p>Hier finden Sie <strong>m&ouml;gliche Indikationen</strong> und Fragestellungen f&uuml;r Psychodiagnostik.</p>', 'priceText': '<p>Die Kosten f&uuml;r Psychodiagnostik werden&nbsp;von allen privaten Krankenkassen sowie von der Beihilfekasse &uuml;bernommen. Privatversicherte und Selbstzahler erhalten eine Rechnung nach der Geb&uuml;hrenordnung f&uuml;r Psychotherapeuten (GOP) mit 2,3-fachem bzw. 1,8-fachem Satz.&nbsp;</p>\n<p>&nbsp;</p>\n<ul>\n<li><strong>biographische Anamnese: 123,34 &euro;<br /></strong>Erhebung einer biographischen Anamnese unter neurosenpsychologischen Gesichtspunkten mit schriftlicher Aufzeichnung zur Einleitung und Indikationsstellung bei tiefenpsychologisch fundierter Psychotherapie, auch in mehreren Sitzungen,&nbsp;GOP-Ziffer 860</li>\n</ul>\n<p>&nbsp;</p>\n<ul>\n<li><strong>probatorische Sitzungen:&nbsp;</strong><strong>92,50 &euro;</strong><strong><br /></strong>Tiefenpsychologisch fundierte Psychotherapie und probatorische Sitzungen, Einzelbehandlung, Dauer mind. 50 Minuten, GOP-Ziffer 861<strong><br /></strong></li>\n</ul>\n<p>&nbsp;</p>\n<ul>\n<li><strong>projektive Testverfahren:&nbsp;</strong><strong>75,75 &euro;<br /></strong>Anwendung und Auswertung projektiver Testverfahren (z.B. Rorschach-Test, TAT) mit schriftlicher Aufzeichnung,&nbsp;GOP-Ziffer 855</li>\n</ul>\n<p>&nbsp;</p>\n<ul>\n<li><strong>Intelligenztest: 37,88 &euro;<br /></strong>Anwendung und Auswertung standardisierter Intelligenz- und Entwicklungstests (HAWIK) mit schriftlicher Aufzeichnung, GOP-Ziffer 856</li>\n</ul>\n<p>&nbsp;</p>\n<ul>\n<li><strong>Fragebogen- und orientierende Testverfahren: 12,17 &euro;</strong><br />Durchf&uuml;hrung und Auswertung von Fragebogenverfahren und orientierenden Testuntersuchungen (z.B. Fragebogentest nach Eysenck, Sceno-Test, Wartegg-Zeichentest, Haus-Baum-Mensch), Ziffer GOP 866</li>\n</ul>', 'image': { 'path': '/cockpit/storage/uploads/2019/03/06/5c800fc1b99c6psychodiagnostik.jpg' }, 'columnWidth': '1/3', '_mby': '5c78dbb16435630838000192', '_by': '5c78dbb16435630838000192', '_o': 1, '_modified': 1552395995, '_created': 1551896405, '_id': '5c800f556435632d34000268', 'children': [] }, { 'name': 'Erziehungs- & Familienberatung', 'description': '<p>Individuelle Problemanalyse mit Beratung zu m&ouml;glichen Ursachen sowie Unterst&uuml;tzung bei der famili&auml;ren Kommunikation von Familien</p>', 'detailText': '<p><strong>Erziehungs- und Familienberatung</strong> ist eine Alternative, wenn Eltern, Familien und Bezugspersonen Unterst&uuml;tzung und Beratung bei Fragen der Erziehung oder famili&auml;ren Kommunikation suchen. In vertrauensvoller und wertsch&auml;tzender Atmosph&auml;re begleite ich Sie dabei, die individuellen Probleme zu untersuchen.</p>\n<p>&nbsp;</p>\n<p>Ein <strong>typischer Ablauf</strong> sieht vor: Nach der genauen Analyse der jeweils vorliegenden Situation erfolgt eine individuelle Beratung. Ich begleite Sie dabei im gesch&uuml;tzten Rahmen eine f&uuml;r passende L&ouml;sung zu finden und berate Sie auch bei der Suche nach passenden Angeboten, wenn weitere Hilfen notwendig erscheinen.</p>', 'priceText': '<p>Erziehungs- und Familienberatung ist eine Leistung, die nicht von den Krankenkassen &uuml;bernommen wird. Sie erhalten daher von mir eine Privatrechnung.</p>\n<p>&nbsp;</p>\n<p>Das <strong>Honorar f&uuml;r Erziehungs- und Familienberatung</strong> betr&auml;gt pro Sitzung (50 Min.): <strong>92,50 &euro;</strong></p>\n<p>&nbsp;</p>\n<p>Bitte beachten Sie, dass es verschiedene kostenfreie Anbieter von Erziehungs- und Familienberatung gibt, wie&nbsp;katholische oder evangelische Beratungsstellen, Caritas oder Diakonie). Bitte informieren Sie sich &uuml;ber das dortoge Angebot, etwaige Wartezeiten und pr&uuml;fen Sie, ob Sie die Leistungen dort in Anspruch nehmen m&ouml;chten.</p>', 'image': { 'path': '/cockpit/storage/uploads/2019/03/06/5c800f8753ad0eb.jpg' }, 'columnWidth': '1/4', '_mby': '5c78dbb16435630838000192', '_by': '5c78dbb16435630838000192', '_o': 2, '_modified': 1552435686, '_created': 1551896469, '_id': '5c800f956435632d340000b7', 'children': [] }, { 'name': 'Supervision', 'description': '<p>Supervision und Fallberatung f&uuml;r Teams und Einzelpersonen aus dem psychosozialen Bereich vor Ort bei Ihnen oder in meiner Praxis</p>', 'detailText': '<p>F&uuml;r<strong> Teams</strong> biete ich Supervision und Fallberatung bei Ihnen vor Ort an. Im Rahmen der Supervision und Fallberatung begleite ich Sie und/oder Ihr Team im Verstehen und bei der Reflexion von F&auml;llen und Teamprozessen. Im gesch&uuml;tzten Rahmen werden diese Prozesse erlebbar. Mit meiner wertsch&auml;tzenden, psychodynamisch gepr&auml;gten Haltung unterst&uuml;tze ich Sie und biete tiefenpsychologische Interventionen an, ohne den Gesamt&uuml;berblick zu verlieren.</p>\n<p>Auftraggeber sind Teams aus dem klinischen oder psychosozialen Bereich, wie Teams aus Kindertagesst&auml;tten, Schulen, Betreuungseinrichtungen oder Heimen.</p>\n<p>&nbsp;</p>\n<p>F&uuml;r<strong> Einzelpersonen</strong> biete ich Supervision auch in meiner Praxis an. Hier stehen die individuellen Fragestellungen und Probleme in Bezug auf die Arbeit im psychosozialen Bereich und die Auswirkungen auf die eigene Gesundheit im Vordergrund.</p>\n<p>&nbsp;</p>\n<p>Der <strong>typische Ablauf</strong> sieht ein Kennenlern- und Beratungsgespr&auml;ch vor, in welchem die Analyse der Ausgangssituation erfolgt. Je nach Anliegen erfolgen zumeist mehrere Termine gemeinsam mit den Beteiligten, damit den Themen der Raum zugestanden werden kann, den diese ben&ouml;tigen.</p>', 'priceText': '<p><strong>Honorar f&uuml;r Einzel-Supervision</strong>: pro Sitzung (50 Min.): <strong>92,50 &euro;</strong></p>\n<p>&nbsp;</p>\n<p><strong>Honorar f&uuml;r Team- und Gruppensupervision</strong>: Das Honorar f&uuml;r Supervision von Teams vor Ort richtet sich nach der Teilnehmerzahl und der Dauer. Bitte stellen Sie eine Anfrage f&uuml;r einen Kostenvoranschlag.</p>\n<p>&nbsp;</p>\n<p>Zur Orientierung eine Beispiel-Rechnung: pro Sitzung (100 Min.) bei 6 Teilnehmern &euro; 320,-</p>', 'image': { 'path': '/cockpit/storage/uploads/2019/03/06/5c80101cd66f1supervision.jpg' }, 'columnWidth': '1/4', '_mby': '5c78dbb16435630838000192', '_by': '5c78dbb16435630838000192', '_o': 3, '_modified': 1552435733, '_created': 1551896613, '_id': '5c8010256435632d340002ad', 'children': [] }, { 'name': 'Fortbildungen & Workshops', 'description': '<p>Bedarfsangepasste Fortbildungen und Workshops zu unterschiedlichen Fragestellungen des psychosozialen Bereichs</p>', 'detailText': "<p>Ich biete <strong>Fortbildungen und Workshops</strong> zu zahlreichen psychosozialen Themen an. Auftraggeber sind Kindertagest&auml;tten, Schulen, Betreuungseinrichtungen, aber auch Vereine und private Organisationen.</p>\n<p>&nbsp;</p>\n<p>Besonders wichtig ist es mir, ein individuelles, m&ouml;glichst passend zugeschnittenes Konzept auszuarbeiten. Hierzu geh&ouml;rt die Bedarfsanalyse im Vorfeld zusammen mit dem Auftraggeber, die Vorbereitungszeit sowie schlie&szlig;lich die Durchf&uuml;hrung vor Ort.&nbsp;</p>\n<p>&nbsp;</p>\n<p>Beispiele f&uuml;r Fortbildungen und Workshops:</p>\n<ul>\n<li>Fr&uuml;hkindliche Bindung - Das Fundament f&uuml;r Reifung und Entwicklung</li>\n<li>Das dynamische Unbewusste - Tiefenpsychologische Erkenntnisse &uuml;ber die Psyche</li>\n<li>Ich bin doch (nur) Lehrer, kein Psychologe - Was Sch&uuml;ler von LehrerInnen brauchen</li>\n<li>AD(H)S - Die Tr&auml;umer und St&ouml;renfriede</li>\n<li>Autismus - Ein Spektrum von Schwierigkeiten?!</li>\n<li>Mobbing und Bullying - Lass' den Hass stecken</li>\n<li>Irgendwas ist doch - Psychologische Erste Hilfe</li>\n</ul>", 'priceText': '<p>Das Honorar f&uuml;r Fortbildungen und Workshops richtet sich nach dem Aufwand, der Teilnehmerzahl sowie der Dauer der Veranstaltung. Auf Anfrage stelle ich Ihnen einen Kostenvoranschlag zur Verf&uuml;gung.</p>', 'image': { 'path': '/cockpit/storage/uploads/2019/03/06/5c801ab25141fNicolas_Mandt_L1008813.jpg' }, 'columnWidth': '1/4', '_mby': '5c78dbb16435630838000192', '_by': '5c78dbb16435630838000192', '_o': 4, '_modified': 1552436047, '_created': 1551896770, '_id': '5c8010c26435632d340002b8', 'children': [] }],
      modal: {
        title: 'test',
        detailText: 'details',
        priceText: 'price',
        showPrice: false
      }
    };
  },

  props: ['menuItem'],
  computed: {
    baseUrl: function baseUrl() {
      return this.$store.getters.baseUrl();
    }
  },
  mounted: function mounted() {
    var _this = this;

    console.log('mounted CardSpace');
    this.$http.get(this.$store.getters.serviceClient().getCollectionUrl(this.$props.menuItem.collection)).then(function (response) {
      if (response.ok) {
        console.log(response.body.entries);
        _this.$data.cards = response.body.entries;
      }
    }).catch(function (error) {
      console.log(error);
    });
  },

  methods: {
    setModalContent: function setModalContent(card, showPrice) {
      this.$data.modal.detailText = card.detailText;
      this.$data.modal.title = card.name;
      this.$data.modal.priceText = card.priceText;
      this.$data.modal.showPrice = showPrice;
    },
    toggleModalViewAndScroll: function toggleModalViewAndScroll() {
      $('.modal').stop().animate({
        scrollTop: 20
      }, 500);
      this.modal.showPrice = !this.modal.showPrice;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "GEYa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GFEB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HCTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var anime = __webpack_require__("657T");
__webpack_require__("5Sqs");

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  mounted: function mounted() {

    var route = this.$route;

    // Scrollspy and smooth scroll
    $('body').scrollspy({
      target: ".navbar",
      offset: 71
    });

    $('.navbar-brand, .navbar a, .hint').on("click", function () {
      console.log('scroll animate');
      //Toggle Class
      $(".active").removeClass("active");
      $(this).closest('li a').addClass("active");
      var theClass = $(this).attr("class");
      $('.' + theClass).parent('li a').addClass('active');
      //Animate
      $('html, body').stop().animate({
        scrollTop: $($(this).attr('data-anchor')).offset().top - 70
      }, 1000);
      $(".navbar-collapse").collapse('hide');
      $(".burger-menu").removeClass("menu-on");
      return false;
    });

    //navbar color after scroll
    $(window).on("scroll", function () {
      var scroll = $(window).scrollTop();

      if (scroll >= 100) {
        $(".navbar").addClass("bg-scroll");
      } else {
        // disable menu bar color change for gdpr and imprint
        if (route.path !== '/gdpr' && route.path != '/imprint' && route.path != '/faq' && route.path != '/blog') {
          $(".navbar").removeClass("bg-scroll");
        }
      }
    });

    //Burger button
    $(".navbar-toggler").on('click', function () {
      $(".burger-menu").toggleClass("menu-on");
    });
  },

  methods: {
    scrollTo: function scrollTo(event) {
      console.log(event);
      $(".active").removeClass("active");
      //event.target.closest('li a').addClass("active");
      //var theClass = event.target.attr("class");
      //$('.' + theClass).parent('li a').addClass('active');
      //Animate
      $('html, body').stop().animate({
        scrollTop: $($(event.target).attr('data-anchor')).offset().top - 70
      }, 1000);
      return false;
    }
  },
  computed: {
    menu: function menu() {
      return this.$store.getters.menu();
    },
    subMenu: function subMenu() {
      return this.$store.getters.subMenu();
    },
    settings: function settings() {
      return this.$store.getters.settings();
    },
    baseUrl: function baseUrl() {
      return this.$store.getters.baseUrl();
    }
  },
  props: []
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "Htul":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"latest-posts p-90-0-60",attrs:{"id":_vm.menuItem.anchor}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section-title mb-60"},[_c('h2',{staticClass:"light dark mb-30"},[_vm._v(_vm._s(_vm.menuItem.name)+" "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.menuItem.nameBold))])]),_vm._v(" "),_c('p',{staticClass:"light opas dark"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-1"},[_vm._v(" ")]),_vm._v(" "),_vm._l((_vm.cards),function(card,index){return _c('div',{key:card.name,staticClass:"col-12 mb-30",class:index < 2 ? 'col-lg-5' : 'col-lg-4'},[_c('div',{staticClass:"blog-card"},[_c('img',{attrs:{"src":_vm.baseUrl + card.image.path,"alt":"blog image"}}),_vm._v(" "),_c('div',{staticClass:"blog-text"},[_c('h3',{staticClass:"dark bold mb-15",staticStyle:{"word-break":"normal"}},[_vm._v(_vm._s(card.name))]),_vm._v(" "),_c('div',{staticClass:"dark light opas mb-30",domProps:{"innerHTML":_vm._s(card.description)}}),_vm._v(" "),_c('a',{staticClass:"button button-2 mr-1",attrs:{"href":"#","data-toggle":"modal","data-target":".cardSpaceDetailModal"},on:{"click":function($event){return _vm.setModalContent(card, false)}}},[_vm._v("mehr"),_c('i',{staticClass:"fas fa-chevron-right"})]),_vm._v(" "),_c('a',{staticClass:"button button-2",attrs:{"href":"#","data-toggle":"modal","data-target":".cardSpaceDetailModal"},on:{"click":function($event){return _vm.setModalContent(card, true)}}},[_vm._v("Kosten"),_c('i',{staticClass:"fas fa-chevron-right"})])])])])})],2)]),_vm._v(" "),_c('div',{staticClass:"modal fade cardSpaceDetailModal",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"myLargeModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"modalTitle"}},[_vm._v(_vm._s(_vm.modal.title))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),(_vm.modal.showPrice)?_c('div',{staticClass:"modal-body"},[_c('h5',[_vm._v("Kosten")]),_vm._v(" "),_c('div',{staticClass:"px-4 py-2",domProps:{"innerHTML":_vm._s(_vm.modal.priceText)}})]):_c('div',{staticClass:"modal-body"},[_c('h5',[_vm._v("Details")]),_vm._v(" "),_c('div',{staticClass:"px-4 py-2",domProps:{"innerHTML":_vm._s(_vm.modal.detailText)}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[(!_vm.modal.showPrice)?_c('button',{staticClass:"button button-2",attrs:{"type":"button"},on:{"click":_vm.toggleModalViewAndScroll}},[_vm._v("Kosten "),_c('i',{staticClass:"fas fa-chevron-right"})]):_vm._e(),_vm._v(" "),(_vm.modal.showPrice)?_c('button',{staticClass:"button button-2",attrs:{"type":"button"},on:{"click":_vm.toggleModalViewAndScroll}},[_vm._v("Details "),_c('i',{staticClass:"fas fa-chevron-right"})]):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hv4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      collection: { 'disclaimerText': 'Klicken Sie hier, um die Karte anzuzeigen', 'googleMapsUrl': 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d5028.937686079963!2d6.939149657672119!3d50.93354190814153!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47bf2501dd2daf01%3A0xcb316be024f90f51!2sBeethovenstra%C3%9Fe+10%2C+50674+K%C3%B6ln!5e0!3m2!1sde!2sde!4v1549620751483', 'placeholderImage': { 'path': '/cockpit/storage/uploads/2019/03/13/5c8930a5609d6blurred_map.jpg' }, 'disclaimerSubText': 'Damit stimmen Sie zu, dass Ihr Browser die Kartendaten von Google lädt, ihre IP Adresse Google bekannt wird, und dass Cookies für die Verwendung der Karte gespeichert werden.', '_mby': '5c78dbb16435630838000192', '_by': '5c78dbb16435630838000192', '_modified': 1552495947, '_created': 1552494775, '_id': '5c8930b76634360ed200026c' },
      showDummy: true,
      dummyUrl: '/static/img/blurred_map.jpg'
    };
  },

  props: ['menuItem'],
  computed: {
    baseUrl: function baseUrl() {
      return this.$store.getters.baseUrl();
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$http.get(this.$store.getters.serviceClient().getCollectionUrl(this.$props.menuItem.collection)).then(function (response) {
      if (response.ok) {
        console.log(response.body.entries);
        _this.$data.collection = response.body.entries[0];
      }
    }).catch(function (error) {
      console.log(error);
    });
  },

  methods: {
    showMap: function showMap(event) {
      this.showDummy = false;
    }
  }
});

/***/ }),

/***/ "JgUp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Imprint_vue__ = __webpack_require__("qa1I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0356127b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Imprint_vue__ = __webpack_require__("oTwp");
function injectStyle (ssrContext) {
  __webpack_require__("GEYa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0356127b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Imprint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0356127b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Imprint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KwUK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"info p-90-0-60",attrs:{"id":_vm.menuItem.anchor}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-30 align-self-center"},[_c('h2',{staticClass:"light dark mb-30"},[_vm._v(_vm._s(_vm.menuItem.name)+" "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.menuItem.nameBold))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-12 info-slider mb-30"},[_c('div',{staticClass:"swiper-container swiper-1 swiper-container-horizontal"},[_c('div',{staticClass:"swiper-wrapper",staticStyle:{"transition-duration":"1100ms","transform":"translate3d(-1270px, 0px, 0px)"}},_vm._l((_vm.images),function(image){return _c('div',{staticClass:"swiper-slide",staticStyle:{"width":"635px"}},[_c('div',{staticClass:"swiper-img",style:('background-image: url(' + image + ')')})])}),0)])]),_vm._v(" "),_vm._m(0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 d-flex justify-content-center"},[_c('div',{attrs:{"id":"swiperPagination"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LUdc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b97e87c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("+VXC");
function injectStyle (ssrContext) {
  __webpack_require__("tQEV")
  __webpack_require__("lSm+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b97e87c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NAvi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      cards: [],
      modal: {
        title: 'test',
        detailText: 'details',
        alternativeTitle: 'price',
        alternativeDetailText: '',
        showAlternative: false
      }
    };
  },

  props: ['menuItem'],
  computed: {
    baseUrl: function baseUrl() {
      return this.$store.getters.baseUrl();
    }
  },
  mounted: function mounted() {
    var _this = this;

    console.log('mounted WideCards');

    $('.button-3').on('click', function () {
      // Animate
      $('html, body').stop().animate({
        scrollTop: $($(this).attr('data-anchor')).offset().top - 90
      }, 1000);
      return false;
    });

    this.$http.get(this.$store.getters.serviceClient().getCollectionUrl(this.$props.menuItem.collection)).then(function (response) {
      if (response.ok) {
        console.log(response.body.entries);
        _this.$data.cards = response.body.entries;
      }
    }).catch(function (error) {
      console.log(error);
    });
  },

  methods: {
    setModalContent: function setModalContent(card, showAlternative) {
      this.$data.modal.detailText = card.button1Content;
      this.$data.modal.title = card.button1Text;
      this.$data.modal.alternativeTitle = card.button2Text;
      this.$data.modal.alternativeDetailText = card.button2Content;
      this.$data.modal.showAlternative = showAlternative;
    },
    toggleModalViewAndScroll: function toggleModalViewAndScroll() {
      $('.modal').stop().animate({
        scrollTop: 20
      }, 500);
      this.modal.showAlternative = !this.modal.showAlternative;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap__ = __webpack_require__("K3J8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery_easing__ = __webpack_require__("Eg1c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery_easing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery_easing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_font_awesome_css_font_awesome_css__ = __webpack_require__("5W1q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_font_awesome_css_font_awesome_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








// import 'bootstrap/dist/css/bootstrap.min.css'


// import Toastr from 'vue-toastr'
// require('vue-toastr/dist/vue-toastr.css')
// require('vue-toastr/src/vue-toastr.less')
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.headers.common['Accept'] = 'application/json';

// Vue.component('vue-toastr', Toastr)
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});
window.Vue = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */];

/***/ }),

/***/ "QwuK":
/***/ (function(module, exports) {

module.exports = {
  pageSettings: {
    'pageName': 'Praxis Mandt',
    'footerLine': 'COPYRIGHT 2019 | NICOLAS MANDT | BEETHOVENSTRASSE 10, 50674 KÖLN',
    'contact1': 'Nicolas Mandt',
    'contact2': 'Dipl. Päd., Kinder- und Jugendlichenpsychotherapeut',
    'contact3': 'Beethovenstraße 10, 50674 Köln',
    'contact4': '0176 - 44 40 14 24',
    'contact5': 'mail@praxismandt.de',
    'headerTitle': 'Herzlich Willkommen auf den Seiten der Praxis Nicolas Mandt',
    'headerSubtitle': 'tiefenpsychologisch fundierte Psychotherapie für Kinder, Jugendliche und junge Erwachsene',
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    'logo': {'path': '/cockpit/storage/uploads/2019/03/01/5c78e4a0de37alogo.png'}
  },
  mainMenu: [{
    'name': '',
    'link': '/#home',
    'anchor': 'home',
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    '_o': 0,
    '_modified': 1551441599,
    '_created': 1551425236,
    '_id': '5c78ded464356308380001b8',
    'nameBold': null,
    '_pid': null,
    'component': 'ParallaxImage',
    'collection': 'contentStartseite',
    'visible': true,
    'menuText': 'Startseite',
    'children': []
  }, {
    'name': 'Das',
    'nameBold': 'Behandlungsangebot',
    'link': '/#services',
    'anchor': 'services',
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    '_o': 1,
    '_modified': 1551895023,
    '_created': 1551425465,
    '_id': '5c78dfb96435630838000225',
    '_pid': null,
    'component': 'CardSpace',
    'collection': 'contentLeistung',
    'visible': true,
    'menuText': 'Behandlungsangebot',
    'children': []
  }, {
    'menuText': 'Zu meiner Person',
    'name': 'Zu meiner',
    'nameBold': 'Person',
    'link': '/#aboutme',
    'anchor': 'aboutme',
    'component': 'TextAndImage',
    'collection': 'contentAboutMe',
    'visible': true,
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    '_o': 2,
    '_modified': 1551898812,
    '_created': 1551898779,
    '_id': '5c80189b6435632d34000071',
    '_pid': null,
    'children': []
  }, {
    'name': 'Die',
    'link': '/#office',
    'anchor': 'office',
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    '_o': 3,
    '_modified': 1552525228,
    '_created': 1551425267,
    '_id': '5c78def36435630838000127',
    'nameBold': 'Praxis',
    '_pid': null,
    'component': 'Gallery',
    'collection': 'contentPraxis',
    'visible': true,
    'menuText': 'Die Praxis',
    'children': []
  }, {
    'name': 'Die',
    'nameBold': 'Kontaktaufnahme',
    'link': '/#contact',
    'anchor': 'contact',
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    '_o': 4,
    '_modified': 1551441629,
    '_created': 1551425515,
    '_id': '5c78dfeb64356308380003ad',
    '_pid': null,
    'component': 'Contact',
    'collection': 'contentKontakt',
    'visible': true,
    'menuText': 'Kontakt',
    'children': []
  }, {
    'name': 'Die',
    'nameBold': 'Anfahrt',
    'link': '/#map',
    'anchor': 'map',
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    '_o': 5,
    '_modified': 1551441620,
    '_created': 1551425492,
    '_id': '5c78dfd464356308380000fb',
    '_pid': null,
    'component': 'Map',
    'collection': 'contentMap',
    'visible': true,
    'menuText': 'Anfahrt',
    'children': []
  }],
  subMenu: [{
    'name': 'Häufig gestellte',
    'nameBold': 'Fragen',
    'link': '/faq',
    'anchor': '#faq',
    'page': 'Faq',
    'collection': 'contentFaq',
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    '_o': 0,
    '_modified': 1552525286,
    '_created': 1551426253,
    '_id': '5c78e2cd64356308380003d3',
    'visible': true,
    'menuText': 'FAQs',
    'children': []
  }, {
    'name': '',
    'nameBold': 'Artikel',
    'link': '/blog',
    'anchor': '#blog',
    'page': 'Blog',
    'collection': 'contentBlog',
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    '_o': 1,
    '_modified': 1551440542,
    '_created': 1551426286,
    '_id': '5c78e2ee6435630838000300',
    'menuText': 'Artikel',
    'visible': null,
    'children': []
  }, {
    'name': '',
    'nameBold': 'Impressum',
    'link': '/imprint',
    'anchor': '#imprint',
    'page': 'Imprint',
    'collection': 'contentImprint',
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    '_o': 2,
    '_modified': 1551440556,
    '_created': 1551426319,
    '_id': '5c78e30f6435630838000051',
    'visible': true,
    'menuText': 'Impressum',
    'children': []
  }, {
    'name': '',
    'nameBold': 'Datenschutz',
    'link': '/gdpr',
    'anchor': '#gdpr',
    'page': 'Gdpr',
    'collection': 'contentGdpr',
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    '_o': 3,
    '_modified': 1551440569,
    '_created': 1551426358,
    '_id': '5c78e3366435630838000104',
    'visible': true,
    'menuText': 'Datenschutz',
    'children': []
  }]
}


/***/ }),

/***/ "SGec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__ = __webpack_require__("CHQz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68b8effa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__ = __webpack_require__("T6MP");
function injectStyle (ssrContext) {
  __webpack_require__("lMG2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68b8effa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68b8effa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Sl/G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T6MP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"blogContainer"}},[_vm._m(0),_vm._v(" "),(_vm.selectedArticle)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"mt-5 mb-1"},[_vm._v(_vm._s(_vm.selectedArticle.headline))]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_c('small',[_c('i',[_vm._v("von Nicolas Mandt am "+_vm._s(new Date(_vm.selectedArticle._created * 1000).toLocaleDateString()))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-4"},[_c('img',{staticClass:"mb-2 img-fluid",attrs:{"src":_vm.baseUrl + _vm.selectedArticle.image.path,"alt":"Article image"}})])]),_vm._v(" "),_c('p',{staticClass:"mb-2",domProps:{"innerHTML":_vm._s(_vm.selectedArticle.article)}}),_vm._v(" "),_c('a',{staticClass:"button button-2 mt-3",attrs:{"href":"#"},on:{"click":function($event){_vm.selectedArticle=null;}}},[_vm._v("Zurück zur Übersicht")]),_vm._v(" "),_vm._m(1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_vm._l((_vm.collection),function(item,index){return [(!item.hide && (!_vm.selectedArticle || item._id != _vm.selectedArticle._id))?_c('div',{key:item._id,staticClass:"col-12 col-sm-6 col-md-6 col-lg-4 mb-5"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":_vm.baseUrl + item.image.path,"alt":"Article image"}}),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v(_vm._s(item.headline))]),_vm._v(" "),_c('p',{staticClass:"card-text",domProps:{"innerHTML":_vm._s(item.intro)}}),_vm._v(" "),_c('p',[_c('small',[_c('i',[_vm._v("von Nicolas Mandt am "+_vm._s(new Date(item._created * 1000).toLocaleDateString()))])])]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary mt-2",attrs:{"href":'/blog?id=' + item._id}},[_vm._v("Mehr lesen")])])])]):_vm._e()]})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"light dark mb-0"},[_vm._v("Blog "),_c('span',{staticClass:"bold"},[_vm._v("Artikel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"mt-5",staticStyle:{"margin-bottom":"15px"}},[_vm._v("Weitere "),_c('span',{staticClass:"bold"},[_vm._v("Artikel")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TVmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("UthT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff3a2d9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("yL0O");
function injectStyle (ssrContext) {
  __webpack_require__("vdDU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ff3a2d9e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff3a2d9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UthT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: {
    settings: function settings() {
      return this.$store.getters.settings();
    },
    baseUrl: function baseUrl() {
      return this.$store.getters.baseUrl();
    }
  },
  props: []
});

/***/ }),

/***/ "YX7S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"privacyContainer"}},_vm._l((_vm.collection),function(item){return _c('div',{domProps:{"innerHTML":_vm._s(item.paragraph)}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Imprint__ = __webpack_require__("JgUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Privacy__ = __webpack_require__("8mQd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Faq__ = __webpack_require__("EMFf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Blog__ = __webpack_require__("SGec");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ParallaxPage__ = __webpack_require__("7OMd");








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'active',
  hashbang: false,
  transitionOnLoad: true,
  routes: [{
    path: '/imprint',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Imprint__["a" /* default */]
  }, {
    path: '/gdpr',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Privacy__["a" /* default */]
  }, {
    path: '/faq',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Faq__["a" /* default */]
  }, {
    path: '/blog',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Blog__["a" /* default */]
  }, {
    path: '/index2.html',
    component: __WEBPACK_IMPORTED_MODULE_6__components_ParallaxPage__["a" /* default */]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_6__components_ParallaxPage__["a" /* default */]
  }]
}));

/***/ }),

/***/ "ZXUl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__("Hv4b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_064f01ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__("AwAH");
function injectStyle (ssrContext) {
  __webpack_require__("l7UF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-064f01ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_064f01ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("8Z0S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e27cd4a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("fWP3");
function injectStyle (ssrContext) {
  __webpack_require__("8kLe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8e27cd4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e27cd4a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bZy6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f0gE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextAndImage_vue__ = __webpack_require__("DiUE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69288d60_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextAndImage_vue__ = __webpack_require__("Ddac");
function injectStyle (ssrContext) {
  __webpack_require__("+lfw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69288d60"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextAndImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69288d60_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextAndImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fWP3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"info p-90-0-60",attrs:{"id":_vm.menuItem.anchor}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-30 align-self-center"},[_c('h2',{staticClass:"light dark mb-30"},[_vm._v(_vm._s(_vm.menuItem.name)+" "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.menuItem.nameBold))])])])]),_vm._v(" "),_c('div',{staticClass:"row formBackground"},[_c('div',{staticClass:"d-none d-lg-flex col-md-6"},[_vm._v(" ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"d-none d-lg-flex col-md-6"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-3 darkBackground pt-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Name*","id":"name"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-3 darkBackground pt-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.phone),expression:"form.phone"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Rückrufnummer*","id":"phone"},domProps:{"value":(_vm.form.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "phone", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"d-none d-lg-flex col-md-6"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 darkBackground pt-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],staticClass:"form-control",attrs:{"type":"email","placeholder":"E-Mail*","id":"email"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"d-none d-lg-flex col-md-6"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 darkBackground pt-2"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.message),expression:"form.message"}],staticClass:"form-control",attrs:{"placeholder":"Nachricht*","id":"message","rows":"5"},domProps:{"value":(_vm.form.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "message", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"d-none d-lg-flex col-md-6"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 darkBackground pt-2"},[(_vm.captchaId)?_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.formUrl + '/captcha.php?id=' + _vm.captchaId}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"button button-2",on:{"click":function($event){return _vm.newCaptcha()}}},[_vm._v("Nicht lesbar?"),_c('i',{staticClass:"fas fa-refresh"})])]),_vm._v(" "),_c('div',{staticClass:"d-none d-lg-flex col-md-6"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 darkBackground pt-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"value"}},[_vm._v("Geben Sie hier den Text auf dem Bild ein.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.value),expression:"form.value"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Text im Prüfbild","id":"value"},domProps:{"value":(_vm.form.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "value", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"d-none d-lg-flex col-md-6"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"col-md-6 darkBackground"},[_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.accept),expression:"form.accept"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"accept"},domProps:{"checked":Array.isArray(_vm.form.accept)?_vm._i(_vm.form.accept,null)>-1:(_vm.form.accept)},on:{"change":function($event){var $$a=_vm.form.accept,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "accept", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "accept", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "accept", $$c)}}}}),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"d-none d-lg-flex col-md-6"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"col-md-2 darkBackground pl-2 pb-5"},[_c('button',{staticClass:"button button-2",attrs:{"disabled":_vm.captchaId == null || !_vm.form.accept || _vm.busy},on:{"click":function($event){return _vm.sendMail()}}},[_vm._v("Senden "),_c('i',{staticClass:"fas fa-envelope"})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 darkBackground"},[(_vm.alert.show)?_c('div',{staticClass:"alert",class:_vm.alert.type},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":"Close"},on:{"click":function($event){_vm.showAlert=false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"alert-heading"},[_vm._v(_vm._s(_vm.alert.header))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.alert.message))])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 col-lg-6 darkBackground pt-2 pb-2"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form-check-label",attrs:{"for":"accept"}},[_vm._v("Ja, ich akzeptiere die "),_c('a',{staticStyle:{"color":"white","font-weight":"bold"},attrs:{"href":"/gdpr","target":"_blank"}},[_vm._v("Datenschutzbedingungen.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fXLi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__ = __webpack_require__("ydYX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d5f8aae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__ = __webpack_require__("KwUK");
function injectStyle (ssrContext) {
  __webpack_require__("n/aa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d5f8aae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gjb/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      collection: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$http.get(this.$store.getters.serviceClient().getCollectionUrl('contentFAQ')).then(function (response) {
      if (response.ok) {
        console.log(response.body.entries);
        _this.$data.collection = response.body.entries;
      }
    }).catch(function (error) {
      console.log(error);
    });

    $('#accordion').on('shown.bs.collapse', function () {
      var panel = $(this).find('.show');
      $('html, body').animate({
        scrollTop: panel.offset().top - 150
      }, 500);
    });
  },

  props: [],
  computed: {},
  methods: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "kz7s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l7UF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lMG2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lSm+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lwmb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParallaxImage_vue__ = __webpack_require__("7hJm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22b098f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParallaxImage_vue__ = __webpack_require__("DE2e");
function injectStyle (ssrContext) {
  __webpack_require__("bZy6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22b098f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParallaxImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22b098f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParallaxImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mgS3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n/aa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oTwp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"imprintContainer"}},_vm._l((_vm.collection),function(item){return _c('div',{domProps:{"innerHTML":_vm._s(item.paragraph)}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var baseUrl = 'https://www.praxismandt.de';
var apiBaseUrl = baseUrl + '/cockpit/api';
var apiKey = '?token=639109f86fca5a7630bb7849e7e9ff';
var fallbackData = __webpack_require__("QwuK");

var client = {
  getSingletonUrl: function getSingletonUrl(name) {
    return apiBaseUrl + '/singletons/get/' + name;
  },
  getCollectionUrl: function getCollectionUrl(name) {
    return apiBaseUrl + '/collections/get/' + name;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    serviceClient: client,
    baseUrl: baseUrl,
    apiKey: apiKey,
    loading: true,
    settings: fallbackData.pageSettings,
    menu: fallbackData.mainMenu,
    subMenu: [] // fallbackData.subMenu
  },
  getters: {
    serviceClient: function serviceClient(state) {
      return function () {
        return state.serviceClient;
      };
    },
    baseUrl: function baseUrl(state) {
      return function () {
        return state.baseUrl;
      };
    },
    apiBaseUrl: function apiBaseUrl(state) {
      return function () {
        return state.apiBaseUrl;
      };
    },
    apiKey: function apiKey(state) {
      return function () {
        return state.apiKey;
      };
    },
    settings: function settings(state) {
      return function () {
        return state.settings;
      };
    },
    menu: function menu(state) {
      return function () {
        return state.menu;
      };
    },
    subMenu: function subMenu(state) {
      return function () {
        return state.subMenu;
      };
    }
  },
  mutations: {
    setSettings: function setSettings(state, payload) {
      state.settings = payload;
    },
    setMenu: function setMenu(state, payload) {
      state.menu = payload;
    },
    setSubMenu: function setSubMenu(state, payload) {
      state.subMenu = payload;
    }
  },
  actions: {
    loadSettings: function loadSettings(context) {
      console.log('loadSettings');
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(client.getSingletonUrl('settings')).then(function (response) {
        console.log(response.body);
        if (response.ok) {
          context.commit('setSettings', response.body);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    loadMenu: function loadMenu(context) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(client.getCollectionUrl('mainMenu')).then(function (response) {
        if (response.ok) {
          console.log(response.body.entries);
          context.commit('setMenu', response.body.entries);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    loadSubMenu: function loadSubMenu(context) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(client.getCollectionUrl('subMenu')).then(function (response) {
        console.log(response.body.entries);
        context.commit('setSubMenu', response.body.entries);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
}));

/***/ }),

/***/ "pXU9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sections_ParallaxImage__ = __webpack_require__("lwmb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sections_Map__ = __webpack_require__("ZXUl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sections_Gallery__ = __webpack_require__("fXLi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sections_CardSpace__ = __webpack_require__("xJGj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sections_Contact__ = __webpack_require__("ZcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sections_TextAndImage__ = __webpack_require__("f0gE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_sections_WideCards__ = __webpack_require__("+MEr");
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Contact: __WEBPACK_IMPORTED_MODULE_4__components_sections_Contact__["a" /* default */],
    CardSpace: __WEBPACK_IMPORTED_MODULE_3__components_sections_CardSpace__["a" /* default */],
    Gallery: __WEBPACK_IMPORTED_MODULE_2__components_sections_Gallery__["a" /* default */],
    ParallaxImage: __WEBPACK_IMPORTED_MODULE_0__components_sections_ParallaxImage__["a" /* default */],
    Map: __WEBPACK_IMPORTED_MODULE_1__components_sections_Map__["a" /* default */],
    TextAndImage: __WEBPACK_IMPORTED_MODULE_5__components_sections_TextAndImage__["a" /* default */],
    WideCards: __WEBPACK_IMPORTED_MODULE_6__components_sections_WideCards__["a" /* default */]
  },
  props: [],
  data: function data() {
    return {};
  },

  computed: {
    menu: function menu() {
      return this.$store.getters.menu();
    }
  },
  mounted: function mounted() {
    console.log('mounted Parallax age');
  },

  methods: {}
});

/***/ }),

/***/ "qa1I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      collection: [{ "paragraph": "<p><strong>IMPRESSUM</strong></p>\n<p>&nbsp;</p>\n<p><strong>Verantwortlicher</strong></p>\n<p>Rechtlich verantwortlich f&uuml;r diese Seite gem&auml;&szlig; &sect; 5 TMG und &sect;6 TDG ist</p>\n<p>Dipl.-P&auml;d., Kinder- und Jugendlichenpsychotherapeut Nicolas Mandt</p>\n<p>&nbsp;</p>\n<p>Name und Sitz der psychotherapeutischen Praxis:</p>\n<p>Praxis Nicolas Mandt</p>\n<p>tiefenpsychologische Psychotherapie f&uuml;r Kinder, Jugendliche und junge Erwachsene</p>\n<p>Beethovenstra&szlig;e 10</p>\n<p>50674 K&ouml;ln</p>\n<p>Kontakt:</p>\n<p>Email: mail@praxismandt.de</p>\n<p>Telefon: 0176 - 44 40 14 24 </p>\n<p>&nbsp;</p>\n<p>Aufsichtsbeh&ouml;rde und zust&auml;ndige Kammer:</p>\n<p>Psychotherapeutenkammer Nordrhein-Westfalen</p>\n<p>Willst&auml;tterstra&szlig;e 10, 40549 D&uuml;sseldorf</p>\n<p>www.ptk-nrw.de &nbsp; </p>\n<p>&nbsp;</p>\n<p>Approbation erteilt durch: Bundesrepublik Deutschland</p>\n<p>Berufsbezeichnung: Kinder- und Jugendlichenpsychotherapeut</p>\n<p>Richtlinienverfahren: tiefenpsychologisch fundierte Psychotherapie</p>\n<p>Eintragung in das Arztregister: 2783349</p>\n<p>&nbsp;</p>\n<p><strong>Geltende berufsrechtliche Regelungen</strong>:</p>\n<p>- Gesetz &uuml;ber die Berufe des Psychologischen Psychotherapeuten und des Kinder- und Jugendlichenpsychotherapeuten (Psychotherapeutengesetz PsychThG), einsehbar unter:</p>\n<p>http://www.gesetze-im-internet.de/psychthg/</p>\n<p>&nbsp;</p>\n<p>- Berufsordnung der Psychotherapeutenkammer NRW, Regelungen,&nbsp;einsehbar unter:</p>\n<p>http://www.ptk-nrw.de</p>\n<p>&nbsp;</p>\n<p>- Geb&uuml;hrenordnung f&uuml;r Psychotherapie (GOP), einsehbar unter:</p>\n<p>https://www.pkv.de/service/rechtsquellen/gesetze-und-verordnungen/gebuehrenordnung-fuer-aerzte-goae.pdf</p>\n<p>&nbsp;</p>\n<p><strong>Hinweis zur Umsatzsteuer</strong></p>\n<p>Gem&auml;&szlig; &sect; 4 Nr. 14 UStG sind heilberufliche Leistungen in Form von Psychotherapie von der Umsatzsteuer befreit.</p>\n<p>&nbsp;</p>\n<p><strong>Angaben zur Berufshaftpflichtversicherung</strong>&nbsp;</p>\n<p>Barmenia Allgemeine Versicherungs-AG,</p>\n<p>Barmenia-Allee 1,</p>\n<p>42119 Wuppertal</p>\n<p>Geltungsraum der Versicherung: Deutschland&nbsp;</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>", "_mby": "5c78dbb16435630838000192", "_by": "5c78dbb16435630838000192", "_o": 0, "_modified": 1552815928, "_created": 1552344127, "_id": "5c86e43f66343617ff000115", "children": [] }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$http.get(this.$store.getters.serviceClient().getCollectionUrl('contentImprint')).then(function (response) {
      if (response.ok) {
        console.log(response.body.entries);
        _this.$data.collection = response.body.entries;
      }
    }).catch(function (error) {
      console.log(error);
    });
  },

  props: [],
  computed: {},
  methods: {}
});

/***/ }),

/***/ "tQEV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tV5o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.menu),function(page,p){return [_c(page.component,{key:p,tag:"component",attrs:{"menuItem":page}})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "teIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("HCTz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b08f64e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("COAt");
function injectStyle (ssrContext) {
  __webpack_require__("2EZ5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b08f64e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b08f64e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vdDU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x29w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__("TVmP");
//
//
//
//
//
//
//
//




var pageData = __webpack_require__("QwuK");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */],
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */]
  },
  data: function data() {
    return {
      pageSettings: pageData.pageSettings,
      mainMenu: pageData.mainMenu
    };
  },
  beforeMount: function beforeMount() {
    this.$store.dispatch('loadSettings');
    this.$store.dispatch('loadMenu');
    this.$store.dispatch('loadSubMenu');
  },

  methods: {}
});

/***/ }),

/***/ "xJGj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardSpace_vue__ = __webpack_require__("Fb3H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cff4e9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardSpace_vue__ = __webpack_require__("Htul");
function injectStyle (ssrContext) {
  __webpack_require__("kz7s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5cff4e9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardSpace_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cff4e9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardSpace_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yL0O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"footer text-lg-left",attrs:{"id":"footer"}},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row mb-30",staticStyle:{"padding-top":"15px"}},[_c('div',{staticClass:"col-12 col-lg-8 mb-30"},[_c('h4',{staticClass:"bold mb-30"},[_vm._v("Kontakt")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-10"},[_c('ul',[_c('li',[_vm._v(_vm._s(_vm.settings.contact1))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.settings.contact2))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.settings.contact3))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.settings.contact4))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.settings.contact5))])])])])]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('p',{staticClass:"light opas copy mb-15"},[_vm._v(_vm._s(_vm.settings.footerLine))])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-10"},[_c('div',{staticClass:"col-12"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2"},[_c('img',{attrs:{"src":__webpack_require__("7Otq"),"alt":"logo","width":"85px"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-4 mb-30"},[_c('h4',{staticClass:"bold mb-30"},[_vm._v("Links")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"/gdpr"}},[_vm._v("Datenschutz")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"/imprint"}},[_vm._v("Impressum")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"/faq"}},[_vm._v("FAQ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"/blog"}},[_vm._v("Artikel")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ydYX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

__webpack_require__("mgS3");
var Swiper = __webpack_require__("gsqX");

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      images: ['/static/img/praxis/p01.jpg', '/static/img/praxis/p02.jpg', '/static/img/praxis/p03.jpg', '/static/img/praxis/p04.jpg', '/static/img/praxis/p05.jpg', '/static/img/praxis/p06.jpg', '/static/img/praxis/p07.jpg', '/static/img/praxis/p08.jpg'],
      swiper: null
    };
  },

  props: ['menuItem'],
  computed: {},
  mounted: function mounted() {
    this.swiper = new Swiper('.swiper-1', {
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,

      autoplay: {
        delay: 6000
      },
      loop: true,
      speed: 1100,
      navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev'
      },
      slidesPerView: 'auto',
      pagination: {
        el: '#swiperPagination',
        type: 'bullets',
        clickable: true
      }
    });
  },
  methods: {}
});

/***/ }),

/***/ "zk0i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"faqContainer"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mt-4 mb-4",attrs:{"id":"accordion"}},[_vm._l((_vm.collection),function(item,index){return [(!item.hide)?_c('div',{key:item._id,staticClass:"card mb-1"},[_c('div',{staticClass:"card-header",attrs:{"id":'heading' + index}},[_c('div',{staticClass:"mb-0"},[_c('button',{staticClass:"btn btn-link",attrs:{"data-toggle":"collapse","data-target":'#collapse' + index,"aria-expanded":"true","aria-controls":'collapse' + index}},[_vm._v("\n              "+_vm._s(item.question)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"collapse",attrs:{"id":'collapse' + index,"aria-labelledby":'heading' + index,"data-parent":"#accordion"}},[_c('div',{staticClass:"card-body",domProps:{"innerHTML":_vm._s(item.answer)}})])]):_vm._e()]})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"light dark mb-30"},[_vm._v("Häufig gestellte "),_c('span',{staticClass:"bold"},[_vm._v("Fragen")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b17b2e75fe948b5d3bbf.js